function PlanHH({ ...props }) {
	return (
		<g id="plan-hh">
			<g id="furniture">
				<polyline
					points="695.76 617.35 695.76 811.92 647.03 811.92 647.03 617.35 695.76 617.35"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="639.33 816.46 634.84 816.46 634.84 814.19 639.33 814.19 639.33 816.46"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="660.72"
					y1="337.01"
					x2="660.72"
					y2="540.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="683.3"
					y1="337.01"
					x2="678.43"
					y2="337.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="675.51"
					y1="337.01"
					x2="670.63"
					y2="337.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.71"
					y1="337.01"
					x2="662.75"
					y2="337.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.75"
					y1="337.01"
					x2="662.75"
					y2="339.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.75"
					y1="342.79"
					x2="662.75"
					y2="347.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.75"
					y1="350.59"
					x2="662.75"
					y2="355.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.75"
					y1="358.39"
					x2="662.75"
					y2="363.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.75"
					y1="366.18"
					x2="662.75"
					y2="371.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.75"
					y1="373.98"
					x2="662.75"
					y2="378.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.75"
					y1="381.78"
					x2="662.75"
					y2="386.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.75"
					y1="389.57"
					x2="662.75"
					y2="394.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.75"
					y1="397.37"
					x2="662.75"
					y2="402.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.75"
					y1="405.17"
					x2="662.75"
					y2="410.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.75"
					y1="412.97"
					x2="662.75"
					y2="417.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.75"
					y1="420.76"
					x2="662.75"
					y2="425.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.75"
					y1="428.56"
					x2="662.75"
					y2="433.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.75"
					y1="436.36"
					x2="662.75"
					y2="441.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.75"
					y1="444.15"
					x2="662.75"
					y2="449.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.75"
					y1="451.95"
					x2="662.75"
					y2="456.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.75"
					y1="459.75"
					x2="662.75"
					y2="464.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.75"
					y1="467.54"
					x2="662.75"
					y2="472.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.75"
					y1="475.34"
					x2="662.75"
					y2="480.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.75"
					y1="483.14"
					x2="662.75"
					y2="488.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.75"
					y1="490.93"
					x2="662.75"
					y2="495.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.75"
					y1="498.73"
					x2="662.75"
					y2="503.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.75"
					y1="506.53"
					x2="662.75"
					y2="511.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.75"
					y1="514.32"
					x2="662.75"
					y2="519.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.75"
					y1="522.12"
					x2="662.75"
					y2="526.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.75"
					y1="529.92"
					x2="662.75"
					y2="534.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.75"
					y1="537.72"
					x2="662.75"
					y2="540.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.75"
					y1="540.58"
					x2="667.71"
					y2="540.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="670.63"
					y1="540.58"
					x2="675.51"
					y2="540.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.43"
					y1="540.58"
					x2="683.3"
					y2="540.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="350.66"
					y1="463.11"
					x2="548.17"
					y2="463.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="350.66"
					y1="456.13"
					x2="350.66"
					y2="461.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="350.66"
					y1="461.08"
					x2="354.39"
					y2="461.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.31"
					y1="461.08"
					x2="362.18"
					y2="461.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.11"
					y1="461.08"
					x2="369.98"
					y2="461.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="372.91"
					y1="461.08"
					x2="377.78"
					y2="461.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="380.7"
					y1="461.08"
					x2="385.57"
					y2="461.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="388.5"
					y1="461.08"
					x2="393.37"
					y2="461.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="396.3"
					y1="461.08"
					x2="401.17"
					y2="461.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="404.09"
					y1="461.08"
					x2="408.97"
					y2="461.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="411.89"
					y1="461.08"
					x2="416.76"
					y2="461.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="419.69"
					y1="461.08"
					x2="424.56"
					y2="461.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="427.49"
					y1="461.08"
					x2="432.36"
					y2="461.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="435.28"
					y1="461.08"
					x2="440.15"
					y2="461.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="443.08"
					y1="461.08"
					x2="447.95"
					y2="461.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="450.88"
					y1="461.08"
					x2="455.75"
					y2="461.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.67"
					y1="461.08"
					x2="463.55"
					y2="461.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="466.47"
					y1="461.08"
					x2="471.34"
					y2="461.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.26"
					y1="461.08"
					x2="479.14"
					y2="461.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.06"
					y1="461.08"
					x2="486.94"
					y2="461.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="489.86"
					y1="461.08"
					x2="494.73"
					y2="461.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="497.66"
					y1="461.08"
					x2="502.53"
					y2="461.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505.45"
					y1="461.08"
					x2="510.33"
					y2="461.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="513.25"
					y1="461.08"
					x2="518.12"
					y2="461.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="521.05"
					y1="461.08"
					x2="525.92"
					y2="461.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.84"
					y1="461.08"
					x2="533.72"
					y2="461.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="536.64"
					y1="461.08"
					x2="541.51"
					y2="461.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.44"
					y1="461.08"
					x2="548.17"
					y2="461.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.17"
					y1="461.08"
					x2="548.17"
					y2="456.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="510.52 878.31 510.52 928.47 460.36 928.47 460.36 878.31 510.52 878.31"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="578.18 54.06 578.18 56.09 505.99 56.09 505.99 54.06 578.18 54.06"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="578.18"
					y1="54.06"
					x2="578.18"
					y2="56.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="578.18"
					y1="56.09"
					x2="505.99"
					y2="56.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505.99"
					y1="56.09"
					x2="505.99"
					y2="54.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505.99"
					y1="54.06"
					x2="578.18"
					y2="54.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="619.53 53.26 585.41 53.26 585.41 57.66 619.53 57.66 619.53 53.26"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="583.81 52.86 621.13 52.86 621.13 53.26 583.81 53.26 583.81 52.86"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="583.81"
					y1="52.86"
					x2="621.13"
					y2="52.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="621.13"
					y1="52.86"
					x2="621.13"
					y2="53.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="621.13"
					y1="53.26"
					x2="583.81"
					y2="53.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.81"
					y1="53.26"
					x2="583.81"
					y2="52.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="619.53"
					y1="57.66"
					x2="585.41"
					y2="57.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="585.41"
					y1="53.26"
					x2="619.53"
					y2="53.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="623.13 57.66 619.53 57.66 619.53 53.26 623.13 53.26 623.13 57.66"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="623.13"
					y1="57.66"
					x2="619.53"
					y2="57.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="619.53"
					y1="57.66"
					x2="619.53"
					y2="53.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="619.53"
					y1="53.26"
					x2="623.13"
					y2="53.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.13"
					y1="53.26"
					x2="623.13"
					y2="57.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="581.81 53.26 585.41 53.26 585.41 57.66 581.81 57.66 581.81 53.26"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="581.81"
					y1="53.26"
					x2="585.41"
					y2="53.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="585.41"
					y1="53.26"
					x2="585.41"
					y2="57.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="585.41"
					y1="57.66"
					x2="581.81"
					y2="57.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="581.81"
					y1="57.66"
					x2="581.81"
					y2="53.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="619.53"
					y1="54.06"
					x2="585.41"
					y2="54.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="624.73 57.26 623.13 57.26 623.13 53.26 621.13 53.26 621.13 52.86 624.73 52.86 624.73 57.26"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="624.73"
					y1="57.26"
					x2="623.13"
					y2="57.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.13"
					y1="57.26"
					x2="623.13"
					y2="53.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.13"
					y1="53.26"
					x2="621.13"
					y2="53.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="621.13"
					y1="53.26"
					x2="621.13"
					y2="52.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="621.13"
					y1="52.86"
					x2="624.73"
					y2="52.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="624.73"
					y1="52.86"
					x2="624.73"
					y2="57.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="580.21 52.86 583.81 52.86 583.81 53.26 581.81 53.26 581.81 57.26 580.21 57.26 580.21 52.86"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="580.21"
					y1="52.86"
					x2="583.81"
					y2="52.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.81"
					y1="52.86"
					x2="583.81"
					y2="53.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.81"
					y1="53.26"
					x2="581.81"
					y2="53.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="581.81"
					y1="53.26"
					x2="581.81"
					y2="57.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="581.81"
					y1="57.26"
					x2="580.21"
					y2="57.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.21"
					y1="57.26"
					x2="580.21"
					y2="52.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="576.15 54.06 580.21 54.06 580.21 66.24 576.15 66.24 576.15 54.06"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="580.21"
					y1="54.06"
					x2="576.15"
					y2="54.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.21"
					y1="66.24"
					x2="580.21"
					y2="54.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.15"
					y1="66.24"
					x2="580.21"
					y2="66.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.15"
					y1="54.06"
					x2="576.15"
					y2="66.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="628.79 54.06 628.79 66.24 624.73 66.24 624.73 54.06 628.79 54.06"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="628.79"
					y1="66.24"
					x2="628.79"
					y2="54.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="624.73"
					y1="66.24"
					x2="628.79"
					y2="66.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="624.73"
					y1="54.06"
					x2="624.73"
					y2="66.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="628.79"
					y1="54.06"
					x2="624.73"
					y2="54.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="503.96 54.06 508.02 54.06 508.02 66.24 503.96 66.24 503.96 54.06"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="508.02"
					y1="54.06"
					x2="503.96"
					y2="54.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.02"
					y1="66.24"
					x2="508.02"
					y2="54.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.96"
					y1="66.24"
					x2="508.02"
					y2="66.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.96"
					y1="54.06"
					x2="503.96"
					y2="66.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="290.88 112.6 292.83 113.19 274.59 173.5 272.64 172.91 290.88 112.6"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="290.88"
					y1="112.6"
					x2="292.83"
					y2="113.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="292.83"
					y1="113.19"
					x2="274.59"
					y2="173.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.59"
					y1="173.5"
					x2="272.64"
					y2="172.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.64"
					y1="172.91"
					x2="290.88"
					y2="112.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="331.45 71.37 332.89 72.8 292.64 113.51 291.19 112.08 331.45 71.37"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="331.45"
					y1="71.37"
					x2="332.89"
					y2="72.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.89"
					y1="72.8"
					x2="292.64"
					y2="113.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="292.64"
					y1="113.51"
					x2="291.19"
					y2="112.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.19"
					y1="112.08"
					x2="331.45"
					y2="71.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="392.69 54.1 393.23 56.06 332.56 72.99 332.01 71.04 392.69 54.1"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="392.69"
					y1="54.1"
					x2="393.23"
					y2="56.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.23"
					y1="56.06"
					x2="332.56"
					y2="72.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.56"
					y1="72.99"
					x2="332.01"
					y2="71.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.01"
					y1="71.04"
					x2="392.69"
					y2="54.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="329.95 72.19 333.45 70.13 339.63 80.63 336.13 82.69 329.95 72.19"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="333.45"
					y1="70.13"
					x2="329.95"
					y2="72.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.63"
					y1="80.63"
					x2="333.45"
					y2="70.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="336.13"
					y1="82.69"
					x2="339.63"
					y2="80.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.95"
					y1="72.19"
					x2="336.13"
					y2="82.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="289.96 114.06 292.04 110.57 302.51 116.8 300.43 120.29 289.96 114.06"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="292.04"
					y1="110.57"
					x2="289.96"
					y2="114.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="302.51"
					y1="116.8"
					x2="292.04"
					y2="110.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="300.43"
					y1="120.29"
					x2="302.51"
					y2="116.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="289.96"
					y1="114.06"
					x2="300.43"
					y2="120.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="271.77 391.99 276.17 391.99 276.17 357.26 271.77 357.26 271.77 391.99"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="271.37 355.66 271.37 393.59 271.77 393.59 271.77 355.66 271.37 355.66"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="271.77"
					y1="355.66"
					x2="271.37"
					y2="355.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.77"
					y1="393.59"
					x2="271.77"
					y2="355.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.37"
					y1="393.59"
					x2="271.77"
					y2="393.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.37"
					y1="355.66"
					x2="271.37"
					y2="393.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.17"
					y1="391.99"
					x2="276.17"
					y2="357.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.77"
					y1="357.26"
					x2="271.77"
					y2="391.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="276.17 395.59 276.17 391.99 271.77 391.99 271.77 395.59 276.17 395.59"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="271.77"
					y1="395.59"
					x2="276.17"
					y2="395.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.77"
					y1="391.99"
					x2="271.77"
					y2="395.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.17"
					y1="391.99"
					x2="271.77"
					y2="391.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.17"
					y1="395.59"
					x2="276.17"
					y2="391.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="271.77 353.67 271.77 357.26 276.17 357.26 276.17 353.67 271.77 353.67"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="276.17"
					y1="353.67"
					x2="271.77"
					y2="353.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.17"
					y1="357.26"
					x2="276.17"
					y2="353.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.77"
					y1="357.26"
					x2="276.17"
					y2="357.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.77"
					y1="353.67"
					x2="271.77"
					y2="357.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.57"
					y1="391.99"
					x2="272.57"
					y2="357.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="275.77 397.19 275.77 395.59 271.77 395.59 271.77 393.59 271.37 393.59 271.37 397.19 275.77 397.19"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="271.37"
					y1="397.19"
					x2="275.77"
					y2="397.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.37"
					y1="393.59"
					x2="271.37"
					y2="397.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.77"
					y1="393.59"
					x2="271.37"
					y2="393.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.77"
					y1="395.59"
					x2="271.77"
					y2="393.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="275.77"
					y1="395.59"
					x2="271.77"
					y2="395.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="275.77"
					y1="397.19"
					x2="275.77"
					y2="395.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="271.37 352.07 271.37 355.66 271.77 355.66 271.77 353.67 275.77 353.67 275.77 352.07 271.37 352.07"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="275.77"
					y1="352.07"
					x2="271.37"
					y2="352.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="275.77"
					y1="353.67"
					x2="275.77"
					y2="352.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.77"
					y1="353.67"
					x2="275.77"
					y2="353.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.77"
					y1="355.66"
					x2="271.77"
					y2="353.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.37"
					y1="355.66"
					x2="271.77"
					y2="355.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.37"
					y1="352.07"
					x2="271.37"
					y2="355.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="272.57 350.04 274.6 350.04 274.6 279.39 272.57 279.39 272.57 350.04"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="272.57"
					y1="279.39"
					x2="272.57"
					y2="350.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.6"
					y1="279.39"
					x2="272.57"
					y2="279.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.6"
					y1="350.04"
					x2="274.6"
					y2="279.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.57"
					y1="350.04"
					x2="274.6"
					y2="350.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="272.57 397.19 284.75 397.19 284.75 401.25 272.57 401.25 272.57 397.19"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="284.75"
					y1="397.19"
					x2="272.57"
					y2="397.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="284.75"
					y1="401.25"
					x2="284.75"
					y2="397.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.57"
					y1="401.25"
					x2="284.75"
					y2="401.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.57"
					y1="397.19"
					x2="272.57"
					y2="401.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="272.57 348.01 284.75 348.01 284.75 352.07 272.57 352.07 272.57 348.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="284.75"
					y1="348.01"
					x2="272.57"
					y2="348.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="284.75"
					y1="352.07"
					x2="284.75"
					y2="348.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.57"
					y1="352.07"
					x2="284.75"
					y2="352.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.57"
					y1="348.01"
					x2="272.57"
					y2="352.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="272.57 277.36 284.75 277.36 284.75 281.42 272.57 281.42 272.57 277.36"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="284.75"
					y1="277.36"
					x2="272.57"
					y2="277.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="284.75"
					y1="281.42"
					x2="284.75"
					y2="277.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.57"
					y1="281.42"
					x2="284.75"
					y2="281.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.57"
					y1="277.36"
					x2="272.57"
					y2="281.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="271.77 722.21 276.17 722.21 276.17 688.13 271.77 688.13 271.77 722.21"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="271.37 686.53 271.37 723.81 271.77 723.81 271.77 686.53 271.37 686.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="271.77"
					y1="686.53"
					x2="271.37"
					y2="686.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.77"
					y1="723.81"
					x2="271.77"
					y2="686.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.37"
					y1="723.81"
					x2="271.77"
					y2="723.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.37"
					y1="686.53"
					x2="271.37"
					y2="723.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.17"
					y1="722.21"
					x2="276.17"
					y2="688.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.77"
					y1="688.13"
					x2="271.77"
					y2="722.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="276.17 725.81 276.17 722.21 271.77 722.21 271.77 725.81 276.17 725.81"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="271.77"
					y1="725.81"
					x2="276.17"
					y2="725.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.77"
					y1="722.21"
					x2="271.77"
					y2="725.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.17"
					y1="722.21"
					x2="271.77"
					y2="722.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.17"
					y1="725.81"
					x2="276.17"
					y2="722.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="271.77 684.53 271.77 688.13 276.17 688.13 276.17 684.53 271.77 684.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="276.17"
					y1="684.53"
					x2="271.77"
					y2="684.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.17"
					y1="688.13"
					x2="276.17"
					y2="684.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.77"
					y1="688.13"
					x2="276.17"
					y2="688.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.77"
					y1="684.53"
					x2="271.77"
					y2="688.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.57"
					y1="722.21"
					x2="272.57"
					y2="688.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="275.77 727.41 275.77 725.81 271.77 725.81 271.77 723.81 271.37 723.81 271.37 727.41 275.77 727.41"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="271.37"
					y1="727.41"
					x2="275.77"
					y2="727.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.37"
					y1="723.81"
					x2="271.37"
					y2="727.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.77"
					y1="723.81"
					x2="271.37"
					y2="723.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.77"
					y1="725.81"
					x2="271.77"
					y2="723.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="275.77"
					y1="725.81"
					x2="271.77"
					y2="725.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="275.77"
					y1="727.41"
					x2="275.77"
					y2="725.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="271.37 682.93 271.37 686.53 271.77 686.53 271.77 684.53 275.77 684.53 275.77 682.93 271.37 682.93"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="275.77"
					y1="682.93"
					x2="271.37"
					y2="682.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="275.77"
					y1="684.53"
					x2="275.77"
					y2="682.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.77"
					y1="684.53"
					x2="275.77"
					y2="684.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.77"
					y1="686.53"
					x2="271.77"
					y2="684.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.37"
					y1="686.53"
					x2="271.77"
					y2="686.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.37"
					y1="682.93"
					x2="271.37"
					y2="686.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="272.57 680.9 274.6 680.9 274.6 598.61 272.57 598.61 272.57 680.9"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="272.57"
					y1="598.61"
					x2="272.57"
					y2="680.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.6"
					y1="598.61"
					x2="272.57"
					y2="598.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.6"
					y1="680.9"
					x2="274.6"
					y2="598.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.57"
					y1="680.9"
					x2="274.6"
					y2="680.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="272.57 727.41 284.75 727.41 284.75 731.47 272.57 731.47 272.57 727.41"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="284.75"
					y1="727.41"
					x2="272.57"
					y2="727.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="284.75"
					y1="731.47"
					x2="284.75"
					y2="727.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.57"
					y1="731.47"
					x2="284.75"
					y2="731.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.57"
					y1="727.41"
					x2="272.57"
					y2="731.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="272.57 678.87 284.75 678.87 284.75 682.93 272.57 682.93 272.57 678.87"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="284.75"
					y1="678.87"
					x2="272.57"
					y2="678.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="284.75"
					y1="682.93"
					x2="284.75"
					y2="678.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.57"
					y1="682.93"
					x2="284.75"
					y2="682.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.57"
					y1="678.87"
					x2="272.57"
					y2="682.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="272.57 596.59 284.75 596.59 284.75 600.64 272.57 600.64 272.57 596.59"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="284.75"
					y1="596.59"
					x2="272.57"
					y2="596.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="284.75"
					y1="600.64"
					x2="284.75"
					y2="596.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.57"
					y1="600.64"
					x2="284.75"
					y2="600.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.57"
					y1="596.59"
					x2="272.57"
					y2="600.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="715.25"
					y1="811.92"
					x2="715.25"
					y2="879.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="715.25"
					y1="795.68"
					x2="712.01"
					y2="795.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="695.76"
					y1="811.92"
					x2="715.25"
					y2="811.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="695.76"
					y1="811.92"
					x2="695.76"
					y2="795.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="631.57"
					y1="50"
					x2="628.79"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="628.79"
					y1="50"
					x2="628.79"
					y2="66.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="628.79"
					y1="66.24"
					x2="631.57"
					y2="66.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="268.51"
					y1="277.36"
					x2="284.75"
					y2="277.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="284.75"
					y1="174.05"
					x2="268.51"
					y2="174.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="445.93"
					y1="933.76"
					x2="322.16"
					y2="933.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="632.93"
					y1="895.42"
					x2="635.98"
					y2="895.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="632.93"
					y1="879.18"
					x2="635.98"
					y2="879.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="632.93"
					y1="879.18"
					x2="632.93"
					y2="895.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="555.78"
					y1="895.42"
					x2="552.73"
					y2="895.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="555.78"
					y1="879.18"
					x2="552.73"
					y2="879.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="555.78"
					y1="879.18"
					x2="555.78"
					y2="895.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="556.79 896.44 556.79 895.42 552.73 895.42 552.73 896.44 556.79 896.44"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="631.92 895.42 631.92 896.44 635.98 896.44 635.98 895.42 631.92 895.42"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="556.79 879.18 556.79 878.16 552.73 878.16 552.73 879.18 556.79 879.18"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="631.92 878.16 631.92 879.18 635.98 879.18 635.98 878.16 631.92 878.16"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="556.79"
					y1="896.44"
					x2="552.73"
					y2="896.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="552.73"
					y1="896.44"
					x2="552.73"
					y2="895.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="552.73"
					y1="895.42"
					x2="556.79"
					y2="895.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="556.79"
					y1="895.42"
					x2="556.79"
					y2="896.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="631.92"
					y1="895.42"
					x2="635.98"
					y2="895.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="635.98"
					y1="895.42"
					x2="635.98"
					y2="896.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="635.98"
					y1="896.44"
					x2="631.92"
					y2="896.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="631.92"
					y1="896.44"
					x2="631.92"
					y2="895.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="556.79"
					y1="879.18"
					x2="552.73"
					y2="879.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="552.73"
					y1="879.18"
					x2="552.73"
					y2="878.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="552.73"
					y1="878.16"
					x2="556.79"
					y2="878.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="556.79"
					y1="878.16"
					x2="556.79"
					y2="879.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="631.92"
					y1="878.16"
					x2="635.98"
					y2="878.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="635.98"
					y1="878.16"
					x2="635.98"
					y2="879.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="635.98"
					y1="879.18"
					x2="631.92"
					y2="879.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="631.92"
					y1="879.18"
					x2="631.92"
					y2="878.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="557.81 895.42 557.81 879.18 556.28 879.18 556.28 895.42 557.81 895.42"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="632.43 895.42 632.43 879.18 630.9 879.18 630.9 895.42 632.43 895.42"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="579.22 827.49 576.7 830.01 628.39 881.69 630.9 879.18 579.22 827.49"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="556.28"
					y1="879.18"
					x2="555.78"
					y2="879.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="556.28"
					y1="895.42"
					x2="555.78"
					y2="895.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.78"
					y1="879.18"
					x2="555.78"
					y2="895.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="632.43"
					y1="879.18"
					x2="632.93"
					y2="879.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="632.43"
					y1="895.42"
					x2="632.93"
					y2="895.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="632.93"
					y1="879.18"
					x2="632.93"
					y2="895.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.81"
					y1="895.42"
					x2="557.81"
					y2="879.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.81"
					y1="879.18"
					x2="556.28"
					y2="879.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="556.28"
					y1="879.18"
					x2="556.28"
					y2="895.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="556.28"
					y1="895.42"
					x2="557.81"
					y2="895.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="632.43"
					y1="895.42"
					x2="632.43"
					y2="879.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="632.43"
					y1="879.18"
					x2="630.9"
					y2="879.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="630.9"
					y1="879.18"
					x2="630.9"
					y2="895.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="630.9"
					y1="895.42"
					x2="632.43"
					y2="895.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="579.22"
					y1="827.49"
					x2="576.7"
					y2="830.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.7"
					y1="830.01"
					x2="628.39"
					y2="881.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="628.39"
					y1="881.69"
					x2="630.9"
					y2="879.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="630.9"
					y1="879.18"
					x2="579.22"
					y2="827.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.78"
					y1="879.18"
					x2="555.78"
					y2="895.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="555.78"
					y1="879.18"
					x2="555.78"
					y2="895.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="555.78"
					y1="879.18"
					x2="552.73"
					y2="879.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="555.78"
					y1="879.18"
					x2="552.73"
					y2="879.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="555.78"
					y1="895.42"
					x2="552.73"
					y2="895.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="555.78"
					y1="895.42"
					x2="552.73"
					y2="895.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="632.93"
					y1="879.18"
					x2="632.93"
					y2="895.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="632.93"
					y1="879.18"
					x2="632.93"
					y2="895.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="632.93"
					y1="879.18"
					x2="635.98"
					y2="879.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="632.93"
					y1="879.18"
					x2="635.98"
					y2="879.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="632.93"
					y1="895.42"
					x2="635.98"
					y2="895.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="632.93"
					y1="895.42"
					x2="635.98"
					y2="895.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="631.57"
					y1="367.13"
					x2="631.57"
					y2="364.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="633.6"
					y1="367.13"
					x2="631.57"
					y2="367.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="641.72"
					y1="367.13"
					x2="641.72"
					y2="364.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="641.72"
					y1="367.13"
					x2="633.6"
					y2="367.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="631.57"
					y1="510.28"
					x2="631.57"
					y2="512.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="633.6"
					y1="510.28"
					x2="631.57"
					y2="510.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="641.72"
					y1="510.28"
					x2="641.72"
					y2="512.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="641.72"
					y1="510.28"
					x2="633.6"
					y2="510.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="641.72"
					y1="540.41"
					x2="641.72"
					y2="510.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="633.6 508.76 631.57 508.76 631.57 509.77 633.6 509.77 633.6 508.76"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="630.55 508.76 630.55 512.82 631.57 512.82 631.57 508.76 630.55 508.76"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="633.6 367.64 631.57 367.64 631.57 368.66 633.6 368.66 633.6 367.64"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="631.57 368.66 631.57 364.6 630.55 364.6 630.55 368.66 631.57 368.66"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="641.72 508.76 641.72 512.82 644.26 512.82 644.26 508.76 641.72 508.76"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="644.26 368.66 644.26 364.6 641.72 364.6 641.72 368.66 644.26 368.66"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="633.6"
					y1="508.76"
					x2="631.57"
					y2="508.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="631.57"
					y1="508.76"
					x2="631.57"
					y2="509.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="631.57"
					y1="509.77"
					x2="633.6"
					y2="509.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.6"
					y1="509.77"
					x2="633.6"
					y2="508.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="630.55"
					y1="508.76"
					x2="630.55"
					y2="512.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="630.55"
					y1="512.82"
					x2="631.57"
					y2="512.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="631.57"
					y1="512.82"
					x2="631.57"
					y2="508.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="631.57"
					y1="508.76"
					x2="630.55"
					y2="508.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.6"
					y1="367.64"
					x2="631.57"
					y2="367.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="631.57"
					y1="367.64"
					x2="631.57"
					y2="368.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="631.57"
					y1="368.66"
					x2="633.6"
					y2="368.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.6"
					y1="368.66"
					x2="633.6"
					y2="367.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="631.57"
					y1="368.66"
					x2="631.57"
					y2="364.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="631.57"
					y1="364.6"
					x2="630.55"
					y2="364.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="630.55"
					y1="364.6"
					x2="630.55"
					y2="368.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="630.55"
					y1="368.66"
					x2="631.57"
					y2="368.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="641.72"
					y1="508.76"
					x2="641.72"
					y2="512.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="641.72"
					y1="512.82"
					x2="644.26"
					y2="512.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="644.26"
					y1="512.82"
					x2="644.26"
					y2="508.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="644.26"
					y1="508.76"
					x2="641.72"
					y2="508.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="644.26"
					y1="368.66"
					x2="644.26"
					y2="364.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="644.26"
					y1="364.6"
					x2="641.72"
					y2="364.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="641.72"
					y1="364.6"
					x2="641.72"
					y2="368.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="641.72"
					y1="368.66"
					x2="644.26"
					y2="368.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="633.6 505.71 633.6 509.77 641.72 509.77 641.72 505.71 633.6 505.71"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="633.6 367.64 633.6 371.7 641.72 371.7 641.72 367.64 633.6 367.64"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="641.72 440.74 641.72 371.7 638.16 371.7 638.16 440.74 641.72 440.74"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="638.16 481.35 638.16 412.31 634.61 412.31 634.61 481.35 638.16 481.35"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="641.72"
					y1="509.77"
					x2="641.72"
					y2="510.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.6"
					y1="509.77"
					x2="633.6"
					y2="510.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="641.72"
					y1="510.28"
					x2="633.6"
					y2="510.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="641.72"
					y1="367.64"
					x2="641.72"
					y2="367.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.6"
					y1="367.64"
					x2="633.6"
					y2="367.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="641.72"
					y1="367.13"
					x2="633.6"
					y2="367.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.6"
					y1="505.71"
					x2="641.72"
					y2="505.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="641.72"
					y1="505.71"
					x2="641.72"
					y2="509.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="641.72"
					y1="509.77"
					x2="633.6"
					y2="509.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.6"
					y1="509.77"
					x2="633.6"
					y2="505.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.6"
					y1="367.64"
					x2="641.72"
					y2="367.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="641.72"
					y1="367.64"
					x2="641.72"
					y2="371.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="641.72"
					y1="371.7"
					x2="633.6"
					y2="371.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.6"
					y1="371.7"
					x2="633.6"
					y2="367.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="641.72"
					y1="440.74"
					x2="638.16"
					y2="440.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.16"
					y1="440.74"
					x2="638.16"
					y2="371.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.16"
					y1="371.7"
					x2="641.72"
					y2="371.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="641.72"
					y1="371.7"
					x2="641.72"
					y2="440.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.16"
					y1="481.35"
					x2="634.61"
					y2="481.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="634.61"
					y1="481.35"
					x2="634.61"
					y2="412.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="634.61"
					y1="412.31"
					x2="638.16"
					y2="412.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.16"
					y1="412.31"
					x2="638.16"
					y2="481.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="641.72"
					y1="510.28"
					x2="633.6"
					y2="510.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="641.72"
					y1="510.28"
					x2="633.6"
					y2="510.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="633.6"
					y1="510.28"
					x2="631.57"
					y2="510.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="641.72"
					y1="510.28"
					x2="641.72"
					y2="512.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="633.6"
					y1="510.28"
					x2="631.57"
					y2="510.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="631.57"
					y1="510.28"
					x2="631.57"
					y2="512.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="631.57"
					y1="510.28"
					x2="631.57"
					y2="512.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="641.72"
					y1="367.13"
					x2="633.6"
					y2="367.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="641.72"
					y1="367.13"
					x2="633.6"
					y2="367.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="633.6"
					y1="367.13"
					x2="631.57"
					y2="367.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="641.72"
					y1="367.13"
					x2="641.72"
					y2="364.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="633.6"
					y1="367.13"
					x2="631.57"
					y2="367.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="631.57"
					y1="367.13"
					x2="631.57"
					y2="364.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="631.57"
					y1="367.13"
					x2="631.57"
					y2="364.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="512.99"
					y1="872.43"
					x2="512.99"
					y2="879.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="508.87"
					y1="872.43"
					x2="511.92"
					y2="872.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="508.87"
					y1="862.28"
					x2="511.92"
					y2="862.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="508.87"
					y1="862.28"
					x2="508.87"
					y2="872.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="460.14"
					y1="872.43"
					x2="457.1"
					y2="872.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="460.14"
					y1="862.28"
					x2="457.1"
					y2="862.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="460.14"
					y1="862.28"
					x2="460.14"
					y2="872.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="512.99"
					y1="862.28"
					x2="508.87"
					y2="862.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="508.87"
					y1="872.43"
					x2="512.99"
					y2="872.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="461.16 873.45 461.16 872.43 457.1 872.43 457.1 873.45 461.16 873.45"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="507.86 872.43 507.86 873.45 511.92 873.45 511.92 872.43 507.86 872.43"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="461.16 862.28 461.16 861.26 457.1 861.26 457.1 862.28 461.16 862.28"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="507.86 861.26 507.86 862.28 511.92 862.28 511.92 861.26 507.86 861.26"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="461.16"
					y1="873.45"
					x2="457.1"
					y2="873.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="457.1"
					y1="873.45"
					x2="457.1"
					y2="872.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="457.1"
					y1="872.43"
					x2="461.16"
					y2="872.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="461.16"
					y1="872.43"
					x2="461.16"
					y2="873.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="507.86"
					y1="872.43"
					x2="511.92"
					y2="872.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="511.92"
					y1="872.43"
					x2="511.92"
					y2="873.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="511.92"
					y1="873.45"
					x2="507.86"
					y2="873.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="507.86"
					y1="873.45"
					x2="507.86"
					y2="872.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="461.16"
					y1="862.28"
					x2="457.1"
					y2="862.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="457.1"
					y1="862.28"
					x2="457.1"
					y2="861.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="457.1"
					y1="861.26"
					x2="461.16"
					y2="861.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="461.16"
					y1="861.26"
					x2="461.16"
					y2="862.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="507.86"
					y1="861.26"
					x2="511.92"
					y2="861.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="511.92"
					y1="861.26"
					x2="511.92"
					y2="862.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="511.92"
					y1="862.28"
					x2="507.86"
					y2="862.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="507.86"
					y1="862.28"
					x2="507.86"
					y2="861.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="462.17 872.43 462.17 862.28 460.65 862.28 460.65 872.43 462.17 872.43"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="508.37 872.43 508.37 862.28 506.84 862.28 506.84 872.43 508.37 872.43"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="475.26 830.7 472.74 833.21 504.33 864.79 506.84 862.28 475.26 830.7"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="460.65"
					y1="862.28"
					x2="460.14"
					y2="862.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.65"
					y1="872.43"
					x2="460.14"
					y2="872.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.14"
					y1="862.28"
					x2="460.14"
					y2="872.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.37"
					y1="862.28"
					x2="508.87"
					y2="862.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.37"
					y1="872.43"
					x2="508.87"
					y2="872.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.87"
					y1="862.28"
					x2="508.87"
					y2="872.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="462.17"
					y1="872.43"
					x2="462.17"
					y2="862.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="462.17"
					y1="862.28"
					x2="460.65"
					y2="862.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.65"
					y1="862.28"
					x2="460.65"
					y2="872.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.65"
					y1="872.43"
					x2="462.17"
					y2="872.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.37"
					y1="872.43"
					x2="508.37"
					y2="862.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.37"
					y1="862.28"
					x2="506.84"
					y2="862.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.84"
					y1="862.28"
					x2="506.84"
					y2="872.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.84"
					y1="872.43"
					x2="508.37"
					y2="872.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="475.26"
					y1="830.7"
					x2="472.74"
					y2="833.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.74"
					y1="833.21"
					x2="504.33"
					y2="864.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.33"
					y1="864.79"
					x2="506.84"
					y2="862.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.84"
					y1="862.28"
					x2="475.26"
					y2="830.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.14"
					y1="862.28"
					x2="460.14"
					y2="872.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="460.14"
					y1="862.28"
					x2="460.14"
					y2="872.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="460.14"
					y1="862.28"
					x2="457.1"
					y2="862.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="460.14"
					y1="862.28"
					x2="457.1"
					y2="862.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="460.14"
					y1="872.43"
					x2="457.1"
					y2="872.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="460.14"
					y1="872.43"
					x2="457.1"
					y2="872.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="508.87"
					y1="862.28"
					x2="508.87"
					y2="872.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="508.87"
					y1="862.28"
					x2="508.87"
					y2="872.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="508.87"
					y1="862.28"
					x2="511.92"
					y2="862.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="508.87"
					y1="862.28"
					x2="511.92"
					y2="862.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="508.87"
					y1="872.43"
					x2="511.92"
					y2="872.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="508.87"
					y1="872.43"
					x2="511.92"
					y2="872.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="456.09"
					y1="750.07"
					x2="456.09"
					y2="747.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="445.93"
					y1="750.07"
					x2="445.93"
					y2="747.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="445.93"
					y1="750.07"
					x2="456.09"
					y2="750.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="445.93"
					y1="827.23"
					x2="445.93"
					y2="830.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="445.93"
					y1="743.7"
					x2="445.93"
					y2="750.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="456.09 751.09 457.1 751.09 457.1 747.03 456.09 747.03 456.09 751.09"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="445.93 826.22 444.92 826.22 444.92 830.27 445.93 830.27 445.93 826.22"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="444.92 751.09 445.93 751.09 445.93 747.03 444.92 747.03 444.92 751.09"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="457.1"
					y1="826.22"
					x2="457.1"
					y2="830.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.09"
					y1="751.09"
					x2="456.09"
					y2="747.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.09"
					y1="747.03"
					x2="457.1"
					y2="747.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="457.1"
					y1="747.03"
					x2="457.1"
					y2="751.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="457.1"
					y1="751.09"
					x2="456.09"
					y2="751.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.93"
					y1="826.22"
					x2="445.93"
					y2="830.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.93"
					y1="830.27"
					x2="444.92"
					y2="830.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="444.92"
					y1="830.27"
					x2="444.92"
					y2="826.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="444.92"
					y1="826.22"
					x2="445.93"
					y2="826.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="444.92"
					y1="751.09"
					x2="444.92"
					y2="747.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="444.92"
					y1="747.03"
					x2="445.93"
					y2="747.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.93"
					y1="747.03"
					x2="445.93"
					y2="751.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.93"
					y1="751.09"
					x2="444.92"
					y2="751.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="456.09 750.58 445.93 750.58 445.93 752.1 456.09 752.1 456.09 750.58"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="394.25 803.79 396.76 806.3 448.44 754.62 445.93 752.1 394.25 803.79"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="445.93"
					y1="826.72"
					x2="445.93"
					y2="827.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.93"
					y1="750.58"
					x2="445.93"
					y2="750.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.09"
					y1="750.58"
					x2="456.09"
					y2="750.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.93"
					y1="750.07"
					x2="456.09"
					y2="750.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.93"
					y1="825.2"
					x2="445.93"
					y2="826.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.09"
					y1="750.58"
					x2="445.93"
					y2="750.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.93"
					y1="750.58"
					x2="445.93"
					y2="752.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.93"
					y1="752.1"
					x2="456.09"
					y2="752.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.09"
					y1="752.1"
					x2="456.09"
					y2="750.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.25"
					y1="803.79"
					x2="396.76"
					y2="806.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="396.76"
					y1="806.3"
					x2="448.44"
					y2="754.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="448.44"
					y1="754.62"
					x2="445.93"
					y2="752.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.93"
					y1="752.1"
					x2="394.25"
					y2="803.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.93"
					y1="827.23"
					x2="445.93"
					y2="830.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="445.93"
					y1="827.23"
					x2="445.93"
					y2="830.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="445.93"
					y1="750.07"
					x2="456.09"
					y2="750.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="445.93"
					y1="750.07"
					x2="456.09"
					y2="750.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="445.93"
					y1="750.07"
					x2="445.93"
					y2="747.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="445.93"
					y1="750.07"
					x2="445.93"
					y2="747.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="456.09"
					y1="750.07"
					x2="456.09"
					y2="747.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="456.09"
					y1="750.07"
					x2="456.09"
					y2="747.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="304.78"
					y1="743.7"
					x2="445.93"
					y2="743.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="544.61"
					y1="743.7"
					x2="547.66"
					y2="743.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="544.61"
					y1="733.54"
					x2="547.66"
					y2="733.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="544.61"
					y1="733.54"
					x2="544.61"
					y2="743.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="467.45"
					y1="743.7"
					x2="464.41"
					y2="743.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="467.45"
					y1="733.54"
					x2="464.41"
					y2="733.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="467.45"
					y1="733.54"
					x2="467.45"
					y2="743.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="548.17"
					y1="733.54"
					x2="544.61"
					y2="733.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="468.47 744.71 468.47 743.7 464.41 743.7 464.41 744.71 468.47 744.71"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="543.59 743.7 543.59 744.71 547.66 744.71 547.66 743.7 543.59 743.7"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="468.47 733.54 468.47 732.53 464.41 732.53 464.41 733.54 468.47 733.54"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="543.59 732.53 543.59 733.54 547.66 733.54 547.66 732.53 543.59 732.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="468.47"
					y1="744.71"
					x2="464.41"
					y2="744.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="464.41"
					y1="744.71"
					x2="464.41"
					y2="743.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="464.41"
					y1="743.7"
					x2="468.47"
					y2="743.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.47"
					y1="743.7"
					x2="468.47"
					y2="744.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="543.59"
					y1="743.7"
					x2="547.66"
					y2="743.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="547.66"
					y1="743.7"
					x2="547.66"
					y2="744.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="547.66"
					y1="744.71"
					x2="543.59"
					y2="744.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="543.59"
					y1="744.71"
					x2="543.59"
					y2="743.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.47"
					y1="733.54"
					x2="464.41"
					y2="733.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="464.41"
					y1="733.54"
					x2="464.41"
					y2="732.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="464.41"
					y1="732.53"
					x2="468.47"
					y2="732.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.47"
					y1="732.53"
					x2="468.47"
					y2="733.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="543.59"
					y1="732.53"
					x2="547.66"
					y2="732.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="547.66"
					y1="732.53"
					x2="547.66"
					y2="733.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="547.66"
					y1="733.54"
					x2="543.59"
					y2="733.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="543.59"
					y1="733.54"
					x2="543.59"
					y2="732.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="469.48 743.7 469.48 733.54 467.96 733.54 467.96 743.7 469.48 743.7"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="544.1 743.7 544.1 733.54 542.58 733.54 542.58 743.7 544.1 743.7"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="490.89 681.85 488.38 684.37 540.07 736.06 542.58 733.54 490.89 681.85"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="467.96"
					y1="733.54"
					x2="467.45"
					y2="733.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.96"
					y1="743.7"
					x2="467.45"
					y2="743.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.45"
					y1="733.54"
					x2="467.45"
					y2="743.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.1"
					y1="733.54"
					x2="544.61"
					y2="733.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.1"
					y1="743.7"
					x2="544.61"
					y2="743.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.61"
					y1="733.54"
					x2="544.61"
					y2="743.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="469.48"
					y1="743.7"
					x2="469.48"
					y2="733.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="469.48"
					y1="733.54"
					x2="467.96"
					y2="733.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.96"
					y1="733.54"
					x2="467.96"
					y2="743.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.96"
					y1="743.7"
					x2="469.48"
					y2="743.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.1"
					y1="743.7"
					x2="544.1"
					y2="733.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.1"
					y1="733.54"
					x2="542.58"
					y2="733.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="542.58"
					y1="733.54"
					x2="542.58"
					y2="743.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="542.58"
					y1="743.7"
					x2="544.1"
					y2="743.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="490.89"
					y1="681.85"
					x2="488.38"
					y2="684.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.38"
					y1="684.37"
					x2="540.07"
					y2="736.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="540.07"
					y1="736.06"
					x2="542.58"
					y2="733.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="542.58"
					y1="733.54"
					x2="490.89"
					y2="681.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.45"
					y1="733.54"
					x2="467.45"
					y2="743.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="467.45"
					y1="733.54"
					x2="467.45"
					y2="743.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="467.45"
					y1="733.54"
					x2="464.41"
					y2="733.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="467.45"
					y1="733.54"
					x2="464.41"
					y2="733.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="467.45"
					y1="743.7"
					x2="464.41"
					y2="743.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="467.45"
					y1="743.7"
					x2="464.41"
					y2="743.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="544.61"
					y1="733.54"
					x2="544.61"
					y2="743.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="544.61"
					y1="733.54"
					x2="544.61"
					y2="743.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="544.61"
					y1="733.54"
					x2="547.66"
					y2="733.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="544.61"
					y1="733.54"
					x2="547.66"
					y2="733.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="544.61"
					y1="743.7"
					x2="547.66"
					y2="743.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="544.61"
					y1="743.7"
					x2="547.66"
					y2="743.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="378.58"
					y1="492.34"
					x2="376.04"
					y2="492.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="378.58"
					y1="490.31"
					x2="378.58"
					y2="492.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="378.58"
					y1="482.19"
					x2="376.04"
					y2="482.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="378.58"
					y1="482.19"
					x2="378.58"
					y2="490.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="521.72"
					y1="492.34"
					x2="524.26"
					y2="492.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="521.72"
					y1="490.31"
					x2="521.72"
					y2="492.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="521.72"
					y1="482.19"
					x2="524.26"
					y2="482.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="521.72"
					y1="482.19"
					x2="521.72"
					y2="490.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="548.17"
					y1="482.19"
					x2="521.72"
					y2="482.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="521.72"
					y1="492.34"
					x2="548.17"
					y2="492.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="520.2 490.31 520.2 492.34 521.22 492.34 521.22 490.31 520.2 490.31"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="520.2 493.36 524.26 493.36 524.26 492.34 520.2 492.34 520.2 493.36"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="379.08 490.31 379.08 492.34 380.1 492.34 380.1 490.31 379.08 490.31"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="380.1 492.34 376.04 492.34 376.04 493.36 380.1 493.36 380.1 492.34"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="520.2 482.19 524.26 482.19 524.26 479.65 520.2 479.65 520.2 482.19"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="380.1 479.65 376.04 479.65 376.04 482.19 380.1 482.19 380.1 479.65"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="520.2"
					y1="490.31"
					x2="520.2"
					y2="492.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="520.2"
					y1="492.34"
					x2="521.22"
					y2="492.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="521.22"
					y1="492.34"
					x2="521.22"
					y2="490.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="521.22"
					y1="490.31"
					x2="520.2"
					y2="490.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="520.2"
					y1="493.36"
					x2="524.26"
					y2="493.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="524.26"
					y1="493.36"
					x2="524.26"
					y2="492.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="524.26"
					y1="492.34"
					x2="520.2"
					y2="492.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="520.2"
					y1="492.34"
					x2="520.2"
					y2="493.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="379.08"
					y1="490.31"
					x2="379.08"
					y2="492.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="379.08"
					y1="492.34"
					x2="380.1"
					y2="492.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="380.1"
					y1="492.34"
					x2="380.1"
					y2="490.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="380.1"
					y1="490.31"
					x2="379.08"
					y2="490.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="380.1"
					y1="492.34"
					x2="376.04"
					y2="492.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="376.04"
					y1="492.34"
					x2="376.04"
					y2="493.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="376.04"
					y1="493.36"
					x2="380.1"
					y2="493.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="380.1"
					y1="493.36"
					x2="380.1"
					y2="492.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="520.2"
					y1="482.19"
					x2="524.26"
					y2="482.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="524.26"
					y1="482.19"
					x2="524.26"
					y2="479.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="524.26"
					y1="479.65"
					x2="520.2"
					y2="479.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="520.2"
					y1="479.65"
					x2="520.2"
					y2="482.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="380.1"
					y1="479.65"
					x2="376.04"
					y2="479.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="376.04"
					y1="479.65"
					x2="376.04"
					y2="482.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="376.04"
					y1="482.19"
					x2="380.1"
					y2="482.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="380.1"
					y1="482.19"
					x2="380.1"
					y2="479.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="517.15 482.19 517.15 490.31 521.22 490.31 521.22 482.19 517.15 482.19"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="379.08 482.19 379.08 490.31 383.15 490.31 383.15 482.19 379.08 482.19"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="452.18 490.31 452.18 486.76 383.15 486.76 383.15 490.31 452.18 490.31"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="492.79 486.76 492.79 483.2 423.75 483.2 423.75 486.76 492.79 486.76"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="521.22"
					y1="490.31"
					x2="521.72"
					y2="490.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="521.22"
					y1="482.19"
					x2="521.72"
					y2="482.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="521.72"
					y1="490.31"
					x2="521.72"
					y2="482.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="379.08"
					y1="490.31"
					x2="378.58"
					y2="490.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="379.08"
					y1="482.19"
					x2="378.58"
					y2="482.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.58"
					y1="490.31"
					x2="378.58"
					y2="482.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="517.15"
					y1="482.19"
					x2="517.15"
					y2="490.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="517.15"
					y1="490.31"
					x2="521.22"
					y2="490.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="521.22"
					y1="490.31"
					x2="521.22"
					y2="482.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="521.22"
					y1="482.19"
					x2="517.15"
					y2="482.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="379.08"
					y1="482.19"
					x2="379.08"
					y2="490.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="379.08"
					y1="490.31"
					x2="383.15"
					y2="490.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.15"
					y1="490.31"
					x2="383.15"
					y2="482.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.15"
					y1="482.19"
					x2="379.08"
					y2="482.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="452.18"
					y1="490.31"
					x2="452.18"
					y2="486.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="452.18"
					y1="486.76"
					x2="383.15"
					y2="486.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.15"
					y1="486.76"
					x2="383.15"
					y2="490.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.15"
					y1="490.31"
					x2="452.18"
					y2="490.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.79"
					y1="486.76"
					x2="492.79"
					y2="483.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.79"
					y1="483.2"
					x2="423.75"
					y2="483.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="423.75"
					y1="483.2"
					x2="423.75"
					y2="486.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="423.75"
					y1="486.76"
					x2="492.79"
					y2="486.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="521.72"
					y1="482.19"
					x2="521.72"
					y2="490.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="521.72"
					y1="482.19"
					x2="521.72"
					y2="490.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="521.72"
					y1="490.31"
					x2="521.72"
					y2="492.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="521.72"
					y1="482.19"
					x2="524.26"
					y2="482.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="521.72"
					y1="490.31"
					x2="521.72"
					y2="492.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="521.72"
					y1="492.34"
					x2="524.26"
					y2="492.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="521.72"
					y1="492.34"
					x2="524.26"
					y2="492.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="378.58"
					y1="482.19"
					x2="378.58"
					y2="490.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="378.58"
					y1="482.19"
					x2="378.58"
					y2="490.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="378.58"
					y1="490.31"
					x2="378.58"
					y2="492.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="378.58"
					y1="482.19"
					x2="376.04"
					y2="482.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="378.58"
					y1="490.31"
					x2="378.58"
					y2="492.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="378.58"
					y1="492.34"
					x2="376.04"
					y2="492.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="378.58"
					y1="492.34"
					x2="376.04"
					y2="492.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="322.16"
					y1="933.76"
					x2="322.16"
					y2="871.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="322.16"
					y1="871.07"
					x2="312.01"
					y2="871.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="312.01"
					y1="871.07"
					x2="304.78"
					y2="871.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="305.07"
					y1="595.49"
					x2="294.92"
					y2="595.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="284.75"
					y1="595.49"
					x2="294.92"
					y2="595.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="392.56"
					y1="50"
					x2="392.56"
					y2="66.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="503.96"
					y1="66.24"
					x2="503.96"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="284.75"
					y1="733.54"
					x2="284.75"
					y2="731.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="268.51"
					y1="731.47"
					x2="284.75"
					y2="731.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="268.51"
					y1="596.59"
					x2="284.75"
					y2="596.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="284.75"
					y1="596.59"
					x2="284.75"
					y2="595.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="284.75"
					y1="401.25"
					x2="268.51"
					y2="401.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="358.1 787.17 359.71 783.54 360.28 779.61 359.71 775.69 358.1 772.06 356.04 769.67 353.47 767.87 347.43 765.56 339.86 764.76 332.45 766.46 325.79 765.91 319.71 763.13 317.99 762.03 314.46 760.74 310.71 760.94 309.23 761.52 305.29 761.52 305.29 763.17 307.09 763.17 305.42 765.92 304.78 769.07 304.78 790.16 305.87 794.24 308.78 797.3 312.79 798.61 313.27 798.61 315.81 798.19 319.8 796.05 325.81 793.29 332.4 792.75 339.84 794.46 347.43 793.66 353.47 791.36 356.04 789.55 358.1 787.17"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="323.52"
					y1="772.1"
					x2="323.52"
					y2="787.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="304.78"
					y1="790.16"
					x2="304.78"
					y2="779.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.54"
					y1="790.16"
					x2="305.54"
					y2="779.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="304.78"
					y1="769.07"
					x2="304.78"
					y2="779.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.54"
					y1="769.07"
					x2="305.54"
					y2="779.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="323.52"
					y1="786.74"
					x2="320.72"
					y2="786.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="320.72"
					y1="786.74"
					x2="320.72"
					y2="784.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="320.72"
					y1="784.42"
					x2="323.52"
					y2="784.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="323.52"
					y1="772.49"
					x2="320.72"
					y2="772.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="320.72"
					y1="772.49"
					x2="320.72"
					y2="774.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="320.72"
					y1="774.81"
					x2="323.52"
					y2="774.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="312.27"
					y1="763.17"
					x2="305.29"
					y2="763.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="312.27"
					y1="761.52"
					x2="305.29"
					y2="761.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.29"
					y1="761.52"
					x2="305.29"
					y2="763.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="312.27"
					y1="761.52"
					x2="312.27"
					y2="763.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.28"
					y1="779.61"
					x2="359.99"
					y2="782.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.99"
					y1="782.13"
					x2="359.34"
					y2="784.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.34"
					y1="784.57"
					x2="358.1"
					y2="787.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="358.1"
					y1="787.17"
					x2="356.05"
					y2="789.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.05"
					y1="789.55"
					x2="353.47"
					y2="791.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.47"
					y1="791.36"
					x2="350.54"
					y2="792.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="350.54"
					y1="792.7"
					x2="347.43"
					y2="793.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.43"
					y1="793.66"
					x2="342.4"
					y2="794.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="342.4"
					y1="794.54"
					x2="339.86"
					y2="794.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.86"
					y1="794.59"
					x2="337.34"
					y2="794.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="337.34"
					y1="794.3"
					x2="333.42"
					y2="793.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="333.42"
					y1="793.16"
					x2="329.62"
					y2="791.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.62"
					y1="791.38"
					x2="326.23"
					y2="789.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.23"
					y1="789.27"
					x2="323.52"
					y2="787.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.4"
					y1="792.75"
					x2="328.88"
					y2="792.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="328.88"
					y1="792.77"
					x2="325.46"
					y2="793.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.46"
					y1="793.35"
					x2="321.78"
					y2="794.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="321.78"
					y1="794.8"
					x2="319.12"
					y2="796.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="319.12"
					y1="796.5"
					x2="316.37"
					y2="797.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.37"
					y1="797.99"
					x2="313.69"
					y2="798.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="313.69"
					y1="798.59"
					x2="311"
					y2="798.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="311"
					y1="798.37"
					x2="308.57"
					y2="797.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="308.57"
					y1="797.32"
					x2="306.61"
					y2="795.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="306.61"
					y1="795.48"
					x2="305.62"
					y2="793.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.62"
					y1="793.68"
					x2="305.06"
					y2="791.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.06"
					y1="791.96"
					x2="304.78"
					y2="790.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.54"
					y1="790.16"
					x2="306.13"
					y2="792.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="306.13"
					y1="792.62"
					x2="307.36"
					y2="794.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="307.36"
					y1="794.09"
					x2="309.08"
					y2="795.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="309.08"
					y1="795.01"
					x2="311.34"
					y2="795.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="311.34"
					y1="795.44"
					x2="313.68"
					y2="795.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="313.68"
					y1="795.54"
					x2="314.84"
					y2="795.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="314.84"
					y1="795.53"
					x2="315.76"
					y2="795.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.76"
					y1="795.04"
					x2="316.03"
					y2="794.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.03"
					y1="794.47"
					x2="317.84"
					y2="788.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="317.84"
					y1="788.09"
					x2="318.38"
					y2="784.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="318.38"
					y1="784.92"
					x2="318.61"
					y2="781.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="318.61"
					y1="781.71"
					x2="318.61"
					y2="779.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.45"
					y1="766.46"
					x2="328.92"
					y2="766.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="328.92"
					y1="766.43"
					x2="325.48"
					y2="765.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.48"
					y1="765.86"
					x2="321.78"
					y2="764.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="321.78"
					y1="764.42"
					x2="316.37"
					y2="761.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.37"
					y1="761.23"
					x2="314.58"
					y2="760.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="314.58"
					y1="760.74"
					x2="312.73"
					y2="760.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="312.73"
					y1="760.62"
					x2="310.92"
					y2="760.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="310.92"
					y1="760.88"
					x2="309.23"
					y2="761.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.54"
					y1="769.07"
					x2="306.13"
					y2="766.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="306.13"
					y1="766.61"
					x2="307.36"
					y2="765.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="307.36"
					y1="765.14"
					x2="309.08"
					y2="764.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="309.08"
					y1="764.22"
					x2="311.34"
					y2="763.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="311.34"
					y1="763.78"
					x2="313.68"
					y2="763.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="313.68"
					y1="763.69"
					x2="314.84"
					y2="763.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="314.84"
					y1="763.7"
					x2="315.76"
					y2="764.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.76"
					y1="764.19"
					x2="316.03"
					y2="764.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.03"
					y1="764.76"
					x2="317.84"
					y2="771.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="317.84"
					y1="771.14"
					x2="318.38"
					y2="774.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="318.38"
					y1="774.31"
					x2="318.61"
					y2="777.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="318.61"
					y1="777.52"
					x2="318.61"
					y2="779.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.28"
					y1="779.61"
					x2="359.99"
					y2="777.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.99"
					y1="777.09"
					x2="359.34"
					y2="774.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.34"
					y1="774.66"
					x2="358.1"
					y2="772.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="358.1"
					y1="772.06"
					x2="356.05"
					y2="769.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.05"
					y1="769.67"
					x2="353.47"
					y2="767.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.47"
					y1="767.87"
					x2="350.54"
					y2="766.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="350.54"
					y1="766.53"
					x2="347.43"
					y2="765.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.43"
					y1="765.56"
					x2="342.4"
					y2="764.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="342.4"
					y1="764.69"
					x2="339.86"
					y2="764.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.86"
					y1="764.64"
					x2="337.34"
					y2="764.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="337.34"
					y1="764.93"
					x2="333.42"
					y2="766.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="333.42"
					y1="766.07"
					x2="329.62"
					y2="767.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.62"
					y1="767.84"
					x2="326.23"
					y2="769.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.23"
					y1="769.95"
					x2="323.52"
					y2="772.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="317.83"
					y1="797.29"
					x2="318.41"
					y2="796.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="318.41"
					y1="796.89"
					x2="319.26"
					y2="795.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="319.26"
					y1="795.72"
					x2="319.47"
					y2="794.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="319.47"
					y1="794.71"
					x2="320.02"
					y2="788.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="320.02"
					y1="788.24"
					x2="320.27"
					y2="781.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="320.27"
					y1="781.74"
					x2="320.27"
					y2="779.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="317.83"
					y1="761.94"
					x2="318.41"
					y2="762.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="318.41"
					y1="762.34"
					x2="319.26"
					y2="763.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="319.26"
					y1="763.51"
					x2="319.47"
					y2="764.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="319.47"
					y1="764.51"
					x2="320.02"
					y2="770.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="320.02"
					y1="770.99"
					x2="320.27"
					y2="777.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="320.27"
					y1="777.49"
					x2="320.27"
					y2="779.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="307.09"
					y1="763.17"
					x2="306.61"
					y2="763.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="306.61"
					y1="763.75"
					x2="305.62"
					y2="765.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.62"
					y1="765.55"
					x2="305.06"
					y2="767.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.06"
					y1="767.27"
					x2="304.78"
					y2="769.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="304.78 803.98 305.59 803.98 305.59 799.92 304.78 799.92 304.78 803.98"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="304.78"
					y1="799.92"
					x2="304.78"
					y2="803.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.59"
					y1="799.92"
					x2="304.78"
					y2="799.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.59"
					y1="803.98"
					x2="305.59"
					y2="799.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="304.78"
					y1="803.98"
					x2="305.59"
					y2="803.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="304.78 755.25 304.78 759.31 305.59 759.31 305.59 755.25 304.78 755.25"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="305.59"
					y1="755.25"
					x2="304.78"
					y2="755.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.59"
					y1="759.31"
					x2="305.59"
					y2="755.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="304.78"
					y1="759.31"
					x2="305.59"
					y2="759.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="304.78"
					y1="755.25"
					x2="304.78"
					y2="759.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="305.59 802.36 312.2 802.36 312.2 801.54 305.59 801.54 305.59 802.36"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="305.59"
					y1="801.54"
					x2="305.59"
					y2="802.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="312.2"
					y1="801.54"
					x2="305.59"
					y2="801.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="312.2"
					y1="802.36"
					x2="312.2"
					y2="801.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.59"
					y1="802.36"
					x2="312.2"
					y2="802.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="305.59 756.87 305.59 757.69 312.2 757.69 312.2 756.87 305.59 756.87"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="312.2"
					y1="756.87"
					x2="305.59"
					y2="756.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="312.2"
					y1="757.69"
					x2="312.2"
					y2="756.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.59"
					y1="757.69"
					x2="312.2"
					y2="757.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.59"
					y1="756.87"
					x2="305.59"
					y2="757.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="310.17 801.54 311.79 801.54 311.79 757.69 310.17 757.69 310.17 801.54"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="310.17"
					y1="757.69"
					x2="310.17"
					y2="801.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="311.79"
					y1="757.69"
					x2="310.17"
					y2="757.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="311.79"
					y1="801.54"
					x2="311.79"
					y2="757.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="310.17"
					y1="801.54"
					x2="311.79"
					y2="801.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="445.93 933.76 445.93 871.07 322.16 871.07 322.16 933.76 445.93 933.76"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="322.16"
					y1="933.76"
					x2="445.93"
					y2="933.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="322.16"
					y1="871.07"
					x2="322.16"
					y2="933.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.93"
					y1="871.07"
					x2="322.16"
					y2="871.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.93"
					y1="933.76"
					x2="445.93"
					y2="871.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.16"
					y1="929.77"
					x2="441.94"
					y2="929.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="441.94"
					y1="929.77"
					x2="441.94"
					y2="875.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="441.94"
					y1="875.06"
					x2="326.16"
					y2="875.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.16"
					y1="875.06"
					x2="326.16"
					y2="929.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.16"
					y1="929.77"
					x2="378.18"
					y2="904.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.16"
					y1="875.06"
					x2="378.18"
					y2="899.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="441.94"
					y1="929.77"
					x2="389.91"
					y2="904.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="441.94"
					y1="875.06"
					x2="389.91"
					y2="899.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="384.04"
					y1="906.41"
					x2="384.04"
					y2="898.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="388.04"
					y1="902.41"
					x2="380.05"
					y2="902.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m390.44,902.41c0-3.53-2.86-6.39-6.39-6.39s-6.39,2.86-6.39,6.39,2.86,6.4,6.39,6.4,6.39-2.86,6.39-6.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m388.04,902.41c0-2.21-1.79-4-4-4s-4,1.79-4,4,1.79,4,4,4,4-1.79,4-4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="322.16 902.41 330.64 908.65 330.64 896.17 322.16 902.41"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="330.64"
					y1="896.17"
					x2="322.16"
					y2="902.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.64"
					y1="908.65"
					x2="330.64"
					y2="896.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="322.16"
					y1="902.41"
					x2="330.64"
					y2="908.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.58"
					y1="902.41"
					x2="337.78"
					y2="902.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.64"
					y1="902.41"
					x2="330.64"
					y2="896.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.64"
					y1="896.17"
					x2="322.16"
					y2="902.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.64"
					y1="902.41"
					x2="330.64"
					y2="908.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.64"
					y1="908.65"
					x2="322.16"
					y2="902.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.41"
					y1="900.57"
					x2="336.93"
					y2="897.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.41"
					y1="904.25"
					x2="336.93"
					y2="906.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="649.43 666.08 695.76 666.08 695.76 620.55 649.43 620.55 649.43 666.08"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="649.43"
					y1="620.55"
					x2="649.43"
					y2="622.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.43"
					y1="625.29"
					x2="649.43"
					y2="630.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.43"
					y1="633.08"
					x2="649.43"
					y2="637.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.43"
					y1="640.88"
					x2="649.43"
					y2="645.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.43"
					y1="648.68"
					x2="649.43"
					y2="653.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.43"
					y1="656.47"
					x2="649.43"
					y2="661.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.43"
					y1="664.27"
					x2="649.43"
					y2="666.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.76"
					y1="620.55"
					x2="693.55"
					y2="620.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.63"
					y1="620.55"
					x2="685.76"
					y2="620.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="682.83"
					y1="620.55"
					x2="677.96"
					y2="620.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="675.03"
					y1="620.55"
					x2="670.16"
					y2="620.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.24"
					y1="620.55"
					x2="662.36"
					y2="620.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="659.44"
					y1="620.55"
					x2="654.57"
					y2="620.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="651.64"
					y1="620.55"
					x2="649.43"
					y2="620.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.76"
					y1="666.08"
					x2="695.76"
					y2="664.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.76"
					y1="661.35"
					x2="695.76"
					y2="656.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.76"
					y1="653.55"
					x2="695.76"
					y2="648.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.76"
					y1="645.75"
					x2="695.76"
					y2="640.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.76"
					y1="637.96"
					x2="695.76"
					y2="633.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.76"
					y1="630.16"
					x2="695.76"
					y2="625.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.76"
					y1="622.36"
					x2="695.76"
					y2="620.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.43"
					y1="666.08"
					x2="651.64"
					y2="666.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="654.57"
					y1="666.08"
					x2="659.44"
					y2="666.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.36"
					y1="666.08"
					x2="667.24"
					y2="666.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="670.16"
					y1="666.08"
					x2="675.03"
					y2="666.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="677.96"
					y1="666.08"
					x2="682.83"
					y2="666.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="685.76"
					y1="666.08"
					x2="690.63"
					y2="666.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="693.55"
					y1="666.08"
					x2="695.76"
					y2="666.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="647.03 620.72 645.63 620.72 645.63 665.91 647.03 665.91 647.03 658.82 645.89 658.82 645.89 627.81 647.03 627.81 647.03 620.72"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="647.03"
					y1="627.81"
					x2="647.03"
					y2="620.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="645.89"
					y1="627.81"
					x2="647.03"
					y2="627.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="645.89"
					y1="658.82"
					x2="645.89"
					y2="627.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="647.03"
					y1="658.82"
					x2="645.89"
					y2="658.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="647.03"
					y1="665.91"
					x2="647.03"
					y2="658.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="645.63"
					y1="665.91"
					x2="647.03"
					y2="665.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="645.63"
					y1="620.72"
					x2="645.63"
					y2="665.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="647.03"
					y1="620.72"
					x2="645.63"
					y2="620.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<polyline
					points="647.03 618.95 647.03 667.68 649.43 667.68 649.43 618.95 647.03 618.95"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="649.43"
					y1="618.95"
					x2="647.03"
					y2="618.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="649.43"
					y1="667.68"
					x2="649.43"
					y2="618.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="647.03"
					y1="667.68"
					x2="649.43"
					y2="667.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="647.03"
					y1="618.95"
					x2="647.03"
					y2="667.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="647.03"
					y1="665.91"
					x2="645.63"
					y2="665.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="645.63"
					y1="665.91"
					x2="645.63"
					y2="620.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="645.63"
					y1="620.72"
					x2="647.03"
					y2="620.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.03"
					y1="667.68"
					x2="647.03"
					y2="618.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.03"
					y1="627.81"
					x2="645.89"
					y2="627.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="645.89"
					y1="627.81"
					x2="645.89"
					y2="658.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="645.89"
					y1="658.82"
					x2="647.03"
					y2="658.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.43"
					y1="667.68"
					x2="647.03"
					y2="667.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.03"
					y1="618.95"
					x2="649.43"
					y2="618.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.43"
					y1="618.95"
					x2="649.43"
					y2="667.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="639.33"
					y1="880"
					x2="639.33"
					y2="811.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="639.33"
					y1="811.92"
					x2="715.25"
					y2="811.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="715.25"
					y1="811.92"
					x2="715.25"
					y2="880"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="644.4"
					y1="880"
					x2="644.4"
					y2="811.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="652.87 673.62 652.87 724.19 653.34 725.32 654.47 725.79 688.33 725.79 689.46 725.32 689.93 724.19 689.93 673.62 689.46 672.48 688.33 672.02 654.47 672.02 653.34 672.48 652.87 673.62"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m652.87,673.62c0-.89.72-1.6,1.6-1.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="688.33"
					y1="672.02"
					x2="654.47"
					y2="672.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m688.33,672.02c.88,0,1.6.71,1.6,1.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="689.93"
					y1="724.19"
					x2="689.93"
					y2="673.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m689.93,724.19c0,.88-.72,1.6-1.6,1.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="654.47"
					y1="725.79"
					x2="688.33"
					y2="725.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m654.47,725.79c-.88,0-1.6-.72-1.6-1.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="652.87"
					y1="673.62"
					x2="652.87"
					y2="724.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.87"
					y1="677.61"
					x2="656.87"
					y2="720.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="658.47"
					y1="721.79"
					x2="680.33"
					y2="721.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="681.93"
					y1="720.19"
					x2="681.93"
					y2="677.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680.33"
					y1="676.01"
					x2="658.47"
					y2="676.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.87"
					y1="677.61"
					x2="656.87"
					y2="677.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m658.47,721.79c-.88,0-1.6-.72-1.6-1.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m681.93,720.19c0,.88-.72,1.6-1.6,1.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m680.33,676.01c.88,0,1.6.72,1.6,1.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m656.87,677.61c0-.88.72-1.6,1.6-1.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m676.33,698.9c0-1.32-1.07-2.4-2.4-2.4s-2.4,1.07-2.4,2.4,1.08,2.4,2.4,2.4,2.4-1.07,2.4-2.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="671.71 698.18 671.2 698.4 670.99 698.9 671.2 699.41 671.71 699.62 687.53 699.62 688.04 699.41 688.25 698.9 688.04 698.39 687.53 698.18 671.71 698.18"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="687.53"
					y1="698.18"
					x2="671.71"
					y2="698.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m687.53,698.18c.4,0,.72.32.72.72s-.32.72-.72.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.71"
					y1="699.62"
					x2="687.53"
					y2="699.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m671.71,699.62h0c-.39,0-.72-.32-.72-.72s.32-.72.72-.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="683.45 697.3 683.45 698.18 687.53 698.18 688.04 698.39 688.25 698.9 688.04 699.41 687.53 699.62 683.45 699.62 683.45 700.5 688.65 700.5 688.65 697.3 683.45 697.3"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="688.65"
					y1="697.3"
					x2="683.45"
					y2="697.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="688.65"
					y1="700.5"
					x2="688.65"
					y2="697.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="683.45"
					y1="700.5"
					x2="688.65"
					y2="700.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="683.45"
					y1="699.62"
					x2="683.45"
					y2="700.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.53"
					y1="699.62"
					x2="683.45"
					y2="699.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m687.53,698.18c.4,0,.72.32.72.72s-.32.72-.72.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="683.45"
					y1="698.18"
					x2="687.53"
					y2="698.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="683.45"
					y1="697.3"
					x2="683.45"
					y2="698.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="680.57 697.33 680.57 698.18 683.37 698.18 683.37 697.33 680.57 697.33"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="683.37"
					y1="697.33"
					x2="680.57"
					y2="697.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="683.37"
					y1="698.18"
					x2="683.37"
					y2="697.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680.57"
					y1="698.18"
					x2="683.37"
					y2="698.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680.57"
					y1="697.33"
					x2="680.57"
					y2="698.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="680.57 700.48 683.37 700.48 683.37 699.62 680.57 699.62 680.57 700.48"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="680.57"
					y1="699.62"
					x2="680.57"
					y2="700.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="683.37"
					y1="699.62"
					x2="680.57"
					y2="699.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="683.37"
					y1="700.48"
					x2="683.37"
					y2="699.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680.57"
					y1="700.48"
					x2="683.37"
					y2="700.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="345.37 867.38 345.37 814.59 304.78 814.59 304.78 867.38 345.37 867.38"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="345.37"
					y1="867.38"
					x2="345.37"
					y2="814.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="304.78"
					y1="867.38"
					x2="304.78"
					y2="814.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.37"
					y1="814.59"
					x2="304.78"
					y2="814.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.37"
					y1="867.38"
					x2="304.78"
					y2="867.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="306.37"
					y1="867.38"
					x2="306.37"
					y2="814.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.73"
					y1="861.28"
					x2="335.73"
					y2="820.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.73"
					y1="820.67"
					x2="311.36"
					y2="820.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="311.36"
					y1="820.67"
					x2="311.36"
					y2="861.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="311.36"
					y1="861.28"
					x2="335.73"
					y2="861.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="337.33"
					y1="862.88"
					x2="337.33"
					y2="819.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="337.33"
					y1="819.07"
					x2="309.77"
					y2="819.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="309.77"
					y1="819.07"
					x2="309.77"
					y2="862.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="309.77"
					y1="862.88"
					x2="337.33"
					y2="862.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m319.26,840.98c0-1.32-1.08-2.4-2.4-2.4s-2.4,1.08-2.4,2.4,1.07,2.4,2.4,2.4,2.4-1.08,2.4-2.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="306.97 842.98 310.32 842.66 311.08 842.4 315.31 841.87 315.87 841.57 316.1 840.98 315.87 840.39 315.31 840.09 311.08 839.56 310.32 839.3 306.97 838.98 305.79 839.36 305.07 840.36 305.07 841.6 305.79 842.6 306.97 842.98"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m306.97,842.98c-1.1,0-2-.89-2-2s.9-2,2-2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="310.32"
					y1="839.3"
					x2="306.97"
					y2="838.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m310.32,839.3c.27.03.53.12.76.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.31"
					y1="840.09"
					x2="311.08"
					y2="839.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m315.31,840.09c.45.06.78.43.78.89s-.34.83-.78.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="311.08"
					y1="842.4"
					x2="315.31"
					y2="841.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m311.08,842.4c-.23.15-.49.24-.76.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="306.97"
					y1="842.98"
					x2="310.32"
					y2="842.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="308.96"
					y1="839.89"
					x2="310.15"
					y2="839.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="310.15"
					y1="842.07"
					x2="308.96"
					y2="842.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="308.96"
					y1="842.07"
					x2="308.96"
					y2="839.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m310.15,839.89c.6,0,1.09.49,1.09,1.09s-.48,1.09-1.09,1.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m311.08,839.56c.48.31.77.84.77,1.42s-.29,1.11-.77,1.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.79"
					y1="895.03"
					x2="467.79"
					y2="882.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.79"
					y1="882.02"
					x2="503.09"
					y2="882.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.36"
					y1="895.03"
					x2="510.52"
					y2="895.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="510.52"
					y1="928.47"
					x2="460.36"
					y2="928.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.36"
					y1="928.47"
					x2="460.36"
					y2="878.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="510.52"
					y1="878.31"
					x2="510.52"
					y2="928.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.36"
					y1="879.24"
					x2="510.52"
					y2="879.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.09"
					y1="895.03"
					x2="503.09"
					y2="882.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.36"
					y1="878.31"
					x2="510.52"
					y2="878.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.03"
					y1="617.35"
					x2="647.03"
					y2="811.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.76"
					y1="617.35"
					x2="647.03"
					y2="617.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="639.33"
					y1="814.19"
					x2="634.84"
					y2="814.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="634.84"
					y1="814.19"
					x2="634.84"
					y2="816.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="634.84"
					y1="816.46"
					x2="639.33"
					y2="816.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.03"
					y1="880"
					x2="647.03"
					y2="878.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.03"
					y1="875.69"
					x2="647.03"
					y2="870.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.03"
					y1="867.89"
					x2="647.03"
					y2="863.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.03"
					y1="860.1"
					x2="647.03"
					y2="855.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.03"
					y1="852.3"
					x2="647.03"
					y2="847.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.03"
					y1="844.5"
					x2="647.03"
					y2="839.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.03"
					y1="836.71"
					x2="647.03"
					y2="831.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.03"
					y1="828.91"
					x2="647.03"
					y2="824.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.03"
					y1="821.11"
					x2="647.03"
					y2="816.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.03"
					y1="813.43"
					x2="647.03"
					y2="811.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.96"
					y1="50"
					x2="628.79"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="628.79"
					y1="66.24"
					x2="503.96"
					y2="66.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.51"
					y1="277.36"
					x2="268.51"
					y2="401.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="284.75"
					y1="401.25"
					x2="284.75"
					y2="277.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.51"
					y1="596.59"
					x2="268.51"
					y2="731.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="284.75"
					y1="731.47"
					x2="284.75"
					y2="596.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m284.75,174.05c1.59-58.87,48.93-106.22,107.81-107.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m268.51,174.05c2.47-67.46,56.59-121.58,124.05-124.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.79"
					y1="922.9"
					x2="503.09"
					y2="922.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.09"
					y1="922.9"
					x2="503.09"
					y2="898.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.09"
					y1="898.75"
					x2="467.79"
					y2="898.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.79"
					y1="898.75"
					x2="467.79"
					y2="922.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="284.75 169.99 284.75 174.05 272.57 174.05 272.57 169.99 284.75 169.99"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="284.75"
					y1="169.99"
					x2="284.75"
					y2="174.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="284.75"
					y1="174.05"
					x2="272.57"
					y2="174.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.57"
					y1="174.05"
					x2="272.57"
					y2="169.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.57"
					y1="169.99"
					x2="284.75"
					y2="169.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="392.56 66.24 388.49 66.24 388.49 54.06 392.56 54.06 392.56 66.24"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="392.56"
					y1="66.24"
					x2="388.49"
					y2="66.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="388.49"
					y1="66.24"
					x2="388.49"
					y2="54.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="388.49"
					y1="54.06"
					x2="392.56"
					y2="54.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="392.56"
					y1="54.06"
					x2="392.56"
					y2="66.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="642.97 730.12 642.97 791.04 695.76 791.04 695.76 730.12 642.97 730.12"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="642.97"
					y1="730.12"
					x2="642.97"
					y2="791.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.76"
					y1="730.12"
					x2="695.76"
					y2="791.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.16"
					y1="730.12"
					x2="694.16"
					y2="791.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="642.97"
					y1="730.12"
					x2="695.76"
					y2="730.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="642.97"
					y1="791.04"
					x2="695.76"
					y2="791.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="645.37"
					y1="734.12"
					x2="645.37"
					y2="787.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="645.37"
					y1="787.04"
					x2="646.97"
					y2="788.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="646.97"
					y1="788.64"
					x2="691.77"
					y2="788.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="691.77"
					y1="788.64"
					x2="693.36"
					y2="787.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="693.36"
					y1="787.04"
					x2="693.36"
					y2="734.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="693.36"
					y1="734.12"
					x2="691.77"
					y2="732.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="691.77"
					y1="732.52"
					x2="646.97"
					y2="732.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="646.97"
					y1="732.52"
					x2="645.37"
					y2="734.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m664.16,745.35c0-4.41-3.58-7.99-7.99-7.99s-7.99,3.58-7.99,7.99,3.58,7.99,7.99,7.99,7.99-3.58,7.99-7.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m688.56,745.35c0-3.31-2.68-5.99-5.99-5.99s-6,2.68-6,5.99,2.68,6,6,6,5.99-2.68,5.99-6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m662.17,775.81c0-3.31-2.68-6-6-6s-6,2.68-6,6,2.68,5.99,6,5.99,6-2.68,6-5.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m690.56,775.81c0-4.42-3.58-7.99-7.99-7.99s-7.99,3.58-7.99,7.99,3.58,7.99,7.99,7.99,7.99-3.58,7.99-7.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.4"
					y1="617.35"
					x2="671.4"
					y2="619.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.4"
					y1="622.54"
					x2="671.4"
					y2="627.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.4"
					y1="630.33"
					x2="671.4"
					y2="635.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.4"
					y1="638.13"
					x2="671.4"
					y2="643"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.4"
					y1="645.93"
					x2="671.4"
					y2="650.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.4"
					y1="653.72"
					x2="671.4"
					y2="658.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.4"
					y1="661.52"
					x2="671.4"
					y2="666.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.4"
					y1="669.32"
					x2="671.4"
					y2="674.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.4"
					y1="677.12"
					x2="671.4"
					y2="681.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.4"
					y1="684.91"
					x2="671.4"
					y2="689.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.4"
					y1="692.71"
					x2="671.4"
					y2="697.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.4"
					y1="700.5"
					x2="671.4"
					y2="705.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.4"
					y1="708.3"
					x2="671.4"
					y2="713.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.4"
					y1="716.1"
					x2="671.4"
					y2="720.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.4"
					y1="723.89"
					x2="671.4"
					y2="728.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.4"
					y1="731.69"
					x2="671.4"
					y2="736.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.4"
					y1="739.49"
					x2="671.4"
					y2="744.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.4"
					y1="747.29"
					x2="671.4"
					y2="752.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.4"
					y1="755.08"
					x2="671.4"
					y2="759.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.4"
					y1="762.88"
					x2="671.4"
					y2="767.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.4"
					y1="770.68"
					x2="671.4"
					y2="775.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.4"
					y1="778.47"
					x2="671.4"
					y2="783.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.4"
					y1="786.27"
					x2="671.4"
					y2="791.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.4"
					y1="794.07"
					x2="671.4"
					y2="798.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.4"
					y1="801.87"
					x2="671.4"
					y2="806.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.4"
					y1="809.66"
					x2="671.4"
					y2="811.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<rect
					x="691.18"
					y="540.4"
					width="4.58"
					height=".17"
					fill="none"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.09"
				/>
				<rect
					x="628.79"
					y="50"
					width="2.77"
					height="16.24"
					fill="none"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.09"
				/>
				<rect
					x="691.18"
					y="540.4"
					width="4.58"
					height=".17"
					fill="none"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.09"
				/>
				<polygon
					points="731.49 795.68 731.49 895.42 632.94 895.42 632.94 879.18 715.25 879.18 715.25 811.92 695.77 811.92 695.77 550.56 631.56 550.56 631.56 510.28 641.71 510.28 641.71 540.4 691.18 540.4 691.18 540.58 695.77 540.58 695.77 540.4 691.18 540.4 691.18 337.01 641.71 337.01 641.71 367.13 631.56 367.13 631.56 50 647.81 50 647.81 320.76 712.01 320.76 712.01 795.68 731.49 795.68"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.09"
				/>
				<polygon
					points="305.07 198.71 305.07 254.21 284.75 254.21 284.75 277.35 268.51 277.35 268.51 174.05 284.75 174.05 284.75 198.71 305.07 198.71"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.09"
				/>
				<polygon
					points="503.96 50 503.96 66.24 392.56 66.24 392.56 50 503.96 50 503.96 50"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.09"
				/>
				<polygon
					points="555.78 879.18 555.78 895.42 529.23 895.42 529.23 950 268.51 950 268.51 731.47 284.75 731.47 284.75 733.54 467.46 733.54 467.46 743.69 456.08 743.69 456.08 750.07 445.93 750.07 445.93 743.69 304.78 743.69 304.78 871.06 322.15 871.06 322.15 933.76 445.93 933.76 445.93 827.23 456.08 827.23 456.08 862.28 460.14 862.28 460.14 872.44 456.08 872.44 456.08 933.76 512.99 933.76 512.99 872.44 508.87 872.44 508.87 862.28 523.14 862.28 523.14 879.18 555.78 879.18"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.09"
				/>
				<polygon
					points="558.32 422.5 558.32 743.69 544.61 743.69 544.61 733.54 548.16 733.54 548.16 492.34 521.72 492.34 521.72 482.19 548.16 482.19 548.16 432.65 350.66 432.65 350.66 482.19 378.58 482.19 378.58 492.34 284.75 492.34 284.75 540 305.07 540 305.07 595.5 284.75 595.5 284.75 596.59 268.51 596.59 268.51 401.25 284.75 401.25 284.75 422.5 558.32 422.5"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.09"
				/>
				<path d="m673.02,647.56v-9.41h3.24c.73,0,1.29.05,1.68.13.54.12,1,.35,1.38.67.5.42.87.96,1.11,1.61.25.65.37,1.4.37,2.23,0,.71-.08,1.35-.25,1.9-.17.55-.38,1.01-.64,1.37-.26.36-.55.64-.86.85-.31.21-.68.36-1.12.47-.44.11-.94.16-1.51.16h-3.4Zm1.25-1.11h2.01c.62,0,1.11-.06,1.46-.17.36-.12.64-.28.85-.49.3-.3.52-.69.69-1.19.17-.5.25-1.11.25-1.82,0-.98-.16-1.74-.49-2.27-.32-.53-.71-.89-1.17-1.07-.33-.13-.87-.19-1.61-.19h-1.98v7.19Zm9.9,1.11l-2.5-9.41h1.28l1.43,6.17c.15.65.29,1.29.4,1.93.24-1.01.38-1.59.42-1.74l1.79-6.36h1.5l1.35,4.76c.34,1.18.58,2.29.73,3.33.12-.59.28-1.28.47-2.05l1.48-6.05h1.25l-2.58,9.41h-1.2l-1.98-7.17c-.17-.6-.27-.97-.3-1.1-.1.43-.19.8-.28,1.1l-2,7.17h-1.27Z" />
				<path d="m674.31,851.61h-1.32l-1.59-2.66c-.15-.25-.29-.46-.42-.63-.14-.18-.28-.32-.42-.43-.14-.11-.3-.19-.46-.24-.16-.05-.35-.08-.56-.08h-.91v4.03h-1.11v-9.48h2.83c.41,0,.8.05,1.14.16.35.1.66.26.91.47.26.21.46.48.61.79.15.31.22.68.22,1.1,0,.33-.05.63-.15.91-.1.27-.24.52-.42.73-.18.22-.4.4-.66.56-.26.15-.54.27-.87.35v.03c.16.07.3.15.41.24.12.09.23.19.34.32.11.12.21.26.31.42.11.15.22.33.35.54l1.78,2.85Zm-5.69-8.48v3.44h1.51c.28,0,.53-.04.77-.13.24-.08.44-.2.61-.36.17-.16.31-.35.4-.58.1-.23.15-.48.15-.77,0-.51-.17-.9-.5-1.18-.33-.29-.8-.43-1.42-.43h-1.52Zm12.16,5.36h-4.78c.02.75.22,1.34.61,1.75.39.41.92.61,1.6.61.76,0,1.46-.25,2.1-.75v1.02c-.6.43-1.38.65-2.36.65s-1.71-.31-2.25-.92c-.55-.62-.82-1.48-.82-2.6,0-1.05.3-1.91.89-2.57.6-.67,1.34-1,2.23-1s1.57.29,2.06.86c.48.57.73,1.37.73,2.39v.57Zm-1.11-.92c0-.63-.16-1.11-.46-1.46-.3-.35-.71-.52-1.24-.52s-.95.18-1.3.55-.58.84-.66,1.43h3.66Zm5.97-5.04c-.21-.12-.45-.18-.72-.18-.76,0-1.14.48-1.14,1.43v1.04h1.59v.93h-1.59v5.84h-1.08v-5.84h-1.16v-.93h1.16v-1.1c0-.71.2-1.27.61-1.68.41-.41.92-.62,1.53-.62.33,0,.59.04.79.12v.98Z" />
				<path d="m686.8,851.75c-.2,0-.38-.07-.52-.22-.14-.15-.21-.32-.21-.52s.07-.38.21-.52c.15-.15.32-.22.52-.22s.38.07.53.22c.15.15.22.32.22.52s-.07.38-.22.52c-.15.15-.32.22-.53.22Z" />
				<path d="m376.7,852.27v-14.72h4.19c1.27,0,2.28.31,3.03.93.75.62,1.12,1.43,1.12,2.43,0,.83-.23,1.56-.68,2.18-.45.62-1.07,1.05-1.87,1.31v.04c.99.12,1.79.49,2.38,1.13.6.63.89,1.45.89,2.46,0,1.26-.45,2.28-1.36,3.06-.9.78-2.04,1.17-3.42,1.17h-4.29Zm1.72-13.16v4.75h1.77c.94,0,1.69-.23,2.23-.68.54-.46.81-1.1.81-1.93,0-1.43-.94-2.15-2.82-2.15h-1.98Zm0,6.3v5.3h2.34c1.01,0,1.8-.24,2.35-.72.56-.48.84-1.14.84-1.97,0-1.74-1.18-2.61-3.55-2.61h-1.98Zm17.62,6.86h-1.68v-1.64h-.04c-.73,1.26-1.81,1.89-3.23,1.89-1.05,0-1.87-.28-2.46-.83-.59-.55-.88-1.29-.88-2.21,0-1.96,1.16-3.11,3.47-3.43l3.15-.44c0-1.79-.72-2.68-2.17-2.68-1.27,0-2.41.43-3.43,1.29v-1.72c1.03-.66,2.22-.99,3.57-.99,2.47,0,3.71,1.31,3.71,3.92v6.84Zm-1.68-5.32l-2.54.35c-.78.11-1.37.3-1.77.59-.4.27-.6.76-.6,1.47,0,.51.18.93.54,1.26.37.32.86.48,1.47.48.83,0,1.52-.29,2.06-.87.55-.59.82-1.33.82-2.23v-1.05Zm9.73,5.21c-.4.22-.92.33-1.57.33-1.84,0-2.76-1.03-2.76-3.08v-6.22h-1.81v-1.44h1.81v-2.57l1.68-.54v3.11h2.65v1.44h-2.65v5.92c0,.7.12,1.21.36,1.51.24.3.64.45,1.19.45.42,0,.79-.12,1.1-.35v1.44Zm10.97.1h-1.68v-6.06c0-2.19-.81-3.29-2.44-3.29-.82,0-1.51.32-2.07.95-.56.63-.84,1.44-.84,2.43v5.95h-1.68v-15.56h1.68v6.8h.04c.81-1.33,1.96-1.99,3.45-1.99,2.37,0,3.55,1.43,3.55,4.28v6.48Z" />
				<path d="m567.35,813h-7.8v-14.72h7.47v1.56h-5.75v4.9h5.32v1.55h-5.32v5.15h6.08v1.56Zm11.35,0h-1.68v-6c0-2.23-.81-3.35-2.44-3.35-.84,0-1.54.32-2.09.95-.55.63-.82,1.43-.82,2.39v6h-1.68v-10.51h1.68v1.75h.04c.79-1.33,1.94-1.99,3.45-1.99,1.15,0,2.03.37,2.64,1.12.61.74.91,1.81.91,3.21v6.43Zm8.06-.1c-.4.22-.92.33-1.57.33-1.84,0-2.76-1.03-2.76-3.08v-6.22h-1.81v-1.44h1.81v-2.57l1.68-.54v3.11h2.65v1.44h-2.65v5.92c0,.7.12,1.21.36,1.51.24.3.64.45,1.19.45.42,0,.79-.12,1.1-.35v1.44Zm7.75-8.71c-.29-.23-.72-.34-1.27-.34-.72,0-1.32.34-1.81,1.02-.48.68-.72,1.6-.72,2.77v5.36h-1.68v-10.51h1.68v2.17h.04c.24-.74.61-1.31,1.1-1.72.49-.42,1.04-.63,1.65-.63.44,0,.77.05,1.01.14v1.75Zm10.22-1.7l-4.84,12.2c-.86,2.18-2.07,3.26-3.63,3.26-.44,0-.8-.04-1.1-.13v-1.51c.36.12.69.18,1,.18.85,0,1.49-.51,1.91-1.52l.84-1.99-4.11-10.49h1.87l2.84,8.09c.03.1.11.37.22.8h.06c.03-.16.1-.42.21-.78l2.99-8.11h1.75Z" />
				<path d="m375.72,611.51v-14.72h4.19c1.27,0,2.28.31,3.03.93.75.62,1.12,1.43,1.12,2.43,0,.83-.23,1.56-.68,2.18-.45.62-1.07,1.05-1.87,1.31v.04c.99.12,1.79.49,2.38,1.13.6.63.89,1.45.89,2.46,0,1.26-.45,2.28-1.36,3.06-.9.78-2.04,1.17-3.42,1.17h-4.29Zm1.72-13.16v4.75h1.77c.94,0,1.69-.23,2.23-.68.54-.46.81-1.1.81-1.93,0-1.43-.94-2.15-2.82-2.15h-1.98Zm0,6.3v5.3h2.34c1.01,0,1.8-.24,2.35-.72.56-.48.84-1.14.84-1.97,0-1.74-1.18-2.61-3.55-2.61h-1.98Zm18.53,2.02h-7.42c.03,1.17.34,2.07.94,2.71.6.64,1.43.95,2.48.95,1.18,0,2.27-.39,3.26-1.17v1.58c-.92.67-2.15,1.01-3.66,1.01s-2.65-.48-3.5-1.43c-.85-.96-1.27-2.3-1.27-4.03,0-1.64.46-2.97,1.39-3.99.93-1.03,2.08-1.55,3.46-1.55s2.44.44,3.19,1.33c.75.89,1.13,2.12,1.13,3.71v.88Zm-1.72-1.43c0-.97-.24-1.73-.71-2.27-.46-.54-1.1-.81-1.92-.81s-1.47.28-2.02.85c-.55.57-.9,1.31-1.03,2.23h5.68Zm13.22,6.26h-1.68v-1.79h-.04c-.78,1.36-1.98,2.03-3.61,2.03-1.32,0-2.38-.47-3.17-1.41-.79-.94-1.18-2.23-1.18-3.85,0-1.74.44-3.13,1.31-4.18s2.04-1.57,3.5-1.57,2.49.57,3.15,1.7h.04v-6.51h1.68v15.56Zm-1.68-4.75v-1.55c0-.85-.28-1.57-.84-2.16-.56-.59-1.27-.88-2.14-.88-1.03,0-1.83.38-2.42,1.13-.59.75-.88,1.79-.88,3.12,0,1.21.28,2.17.84,2.87.57.7,1.33,1.05,2.28,1.05s1.7-.34,2.28-1.02c.59-.68.88-1.53.88-2.57Zm10.56-4.05c-.29-.23-.72-.34-1.27-.34-.72,0-1.32.34-1.81,1.02-.48.68-.72,1.6-.72,2.77v5.36h-1.68v-10.51h1.68v2.17h.04c.24-.74.61-1.31,1.1-1.72.49-.42,1.04-.63,1.65-.63.44,0,.77.05,1.01.14v1.75Zm6.21,9.05c-1.55,0-2.8-.49-3.73-1.47-.92-.99-1.39-2.29-1.39-3.91,0-1.77.48-3.14,1.45-4.14.96-.99,2.27-1.49,3.91-1.49s2.79.48,3.66,1.45c.88.96,1.32,2.3,1.32,4.01s-.48,3.02-1.43,4.03c-.94,1.01-2.21,1.51-3.81,1.51Zm.12-9.59c-1.08,0-1.94.37-2.57,1.11-.63.73-.94,1.75-.94,3.04s.32,2.23.95,2.95c.64.72,1.49,1.08,2.56,1.08s1.92-.35,2.5-1.06c.59-.7.88-1.71.88-3.01s-.29-2.33-.88-3.04c-.58-.71-1.42-1.07-2.5-1.07Zm12.18,9.59c-1.55,0-2.8-.49-3.73-1.47-.92-.99-1.39-2.29-1.39-3.91,0-1.77.48-3.14,1.45-4.14.97-.99,2.27-1.49,3.91-1.49s2.79.48,3.66,1.45c.88.96,1.32,2.3,1.32,4.01s-.48,3.02-1.43,4.03c-.94,1.01-2.21,1.51-3.81,1.51Zm.12-9.59c-1.08,0-1.94.37-2.57,1.11-.63.73-.94,1.75-.94,3.04s.32,2.23.95,2.95c.64.72,1.49,1.08,2.56,1.08s1.92-.35,2.5-1.06c.59-.7.88-1.71.88-3.01s-.29-2.33-.88-3.04c-.58-.71-1.42-1.07-2.5-1.07h0Zm22.71,9.34h-1.68v-6.04c0-1.16-.18-2.01-.54-2.53-.36-.52-.96-.78-1.81-.78-.72,0-1.33.33-1.84.99-.5.66-.75,1.44-.75,2.36v6h-1.68v-6.24c0-2.07-.8-3.1-2.39-3.1-.74,0-1.35.31-1.83.93-.48.62-.72,1.42-.72,2.41v6h-1.68v-10.51h1.68v1.66h.04c.75-1.27,1.83-1.91,3.26-1.91.72,0,1.34.2,1.88.61.53.4.9.92,1.1,1.57.78-1.45,1.94-2.18,3.49-2.18,2.31,0,3.47,1.43,3.47,4.28v6.48Z" />
				<path d="m379.92,633.33h-1.22v-9.25c-.09.09-.23.2-.42.33-.18.12-.38.24-.61.36-.22.12-.46.23-.72.34-.25.1-.49.19-.73.25v-1.24c.27-.07.55-.17.85-.3.3-.13.6-.27.89-.43.29-.16.57-.32.83-.49.26-.17.48-.34.67-.51h.46v10.95Zm10.47-5.4c0,.9-.08,1.69-.25,2.38-.16.69-.39,1.28-.7,1.75-.3.47-.68.83-1.13,1.08-.44.24-.95.37-1.52.37-.54,0-1.02-.12-1.44-.35-.42-.24-.77-.58-1.06-1.04-.29-.45-.51-1.01-.66-1.66-.15-.66-.22-1.42-.22-2.27,0-.94.08-1.76.23-2.48.16-.72.39-1.32.69-1.8.3-.49.68-.85,1.13-1.1.45-.25.97-.37,1.55-.37,2.24,0,3.37,1.83,3.37,5.49Zm-1.25.12c0-3.05-.72-4.57-2.17-4.57-1.53,0-2.29,1.55-2.29,4.65,0,2.89.75,4.34,2.25,4.34s2.22-1.47,2.22-4.42Z" />
				<rect x="392.25" y="622.62" width="1.08" height="3.34" />
				<path d="m401.99,627.33c0,.98-.1,1.85-.29,2.62-.19.76-.48,1.41-.85,1.94-.37.53-.83.93-1.37,1.21-.54.27-1.15.41-1.84.41s-1.33-.12-1.87-.37v-1.17c.59.33,1.22.5,1.9.5.48,0,.91-.1,1.29-.3.38-.2.71-.49.97-.87.26-.38.47-.85.6-1.41.14-.56.21-1.2.21-1.92h-.03c-.46.92-1.25,1.38-2.39,1.38-.46,0-.88-.08-1.26-.24-.38-.16-.71-.39-.99-.69-.28-.3-.5-.65-.65-1.06-.15-.41-.23-.86-.23-1.35,0-.53.08-1.01.25-1.45.17-.44.41-.81.72-1.13.31-.32.67-.56,1.09-.74.42-.17.88-.26,1.38-.26.54,0,1.01.11,1.43.33.42.21.77.53,1.05.95.28.41.5.92.65,1.53.15.61.22,1.3.22,2.08Zm-1.32-1.1c0-.41-.05-.79-.16-1.13-.1-.34-.25-.63-.44-.87-.19-.24-.42-.43-.68-.56-.26-.13-.54-.2-.85-.2s-.57.06-.82.18c-.25.11-.48.28-.66.49-.18.21-.33.46-.44.75-.1.29-.16.6-.16.95,0,.38.05.72.15,1.02.1.3.25.55.44.76.19.2.42.36.68.47.27.11.56.16.89.16.28,0,.55-.05.8-.16.25-.11.47-.25.66-.43.19-.18.34-.4.44-.64.11-.25.16-.52.16-.8Z" />
				<path d="m405.05,622.62v3.34h-1.08v-3.34h1.08Zm2.48,0v3.34h-1.08v-3.34h1.08Z" />
				<path d="m419.77,625.68l-2.57,3.87,2.52,3.78h-1.43l-1.5-2.48c-.09-.15-.21-.35-.34-.58h-.03s-.14.24-.35.58l-1.53,2.48h-1.41l2.61-3.75-2.49-3.9h1.43l1.48,2.61c.11.19.22.39.32.6h.03l1.91-3.21h1.35Z" />
				<path d="m429.56,633.33h-1.22v-9.25c-.09.09-.23.2-.42.33-.18.12-.38.24-.61.36-.22.12-.46.23-.72.34-.25.1-.49.19-.73.25v-1.24c.27-.07.55-.17.85-.3.3-.13.6-.27.89-.43.29-.16.57-.32.83-.49.26-.17.48-.34.67-.51h.46v10.95Zm10.47-5.4c0,.9-.08,1.69-.25,2.38-.16.69-.39,1.28-.7,1.75-.3.47-.68.83-1.13,1.08-.44.24-.95.37-1.52.37-.54,0-1.02-.12-1.44-.35-.42-.24-.77-.58-1.06-1.04s-.51-1.01-.66-1.66c-.15-.66-.22-1.42-.22-2.27,0-.94.08-1.76.23-2.48.16-.72.39-1.32.69-1.8.3-.49.68-.85,1.13-1.1.45-.25.97-.37,1.55-.37,2.24,0,3.37,1.83,3.37,5.49Zm-1.25.12c0-3.05-.72-4.57-2.17-4.57-1.53,0-2.29,1.55-2.29,4.65,0,2.89.75,4.34,2.25,4.34s2.22-1.47,2.22-4.42Z" />
				<rect x="441.88" y="622.62" width="1.08" height="3.34" />
				<path d="m449.54,633.33h-1.22v-9.25c-.09.09-.23.2-.42.33-.18.12-.38.24-.61.36-.22.12-.46.23-.72.34-.25.1-.49.19-.73.25v-1.24c.27-.07.55-.17.85-.3.3-.13.6-.27.89-.43.29-.16.57-.32.83-.49.26-.17.48-.34.67-.51h.46v10.95Z" />
				<path d="m454.69,622.62v3.34h-1.08v-3.34h1.08Zm2.48,0v3.34h-1.08v-3.34h1.08Z" />
				<path d="m576.59,693.13h-2.4l-5.69-6.73c-.21-.25-.34-.42-.39-.51h-.04v7.25h-1.72v-14.72h1.72v6.92h.04c.1-.15.23-.32.39-.5l5.5-6.42h2.15l-6.31,7.06,6.75,7.66Zm2.57-13.18c-.3,0-.56-.1-.77-.31-.21-.21-.32-.47-.32-.78s.11-.57.32-.78c.21-.21.47-.32.77-.32s.57.11.78.32c.22.21.33.47.33.78s-.11.56-.33.77c-.21.21-.47.32-.78.32Zm.82,13.18h-1.68v-10.51h1.68v10.51Zm8.27-.1c-.4.22-.92.33-1.57.33-1.84,0-2.76-1.03-2.76-3.08v-6.22h-1.81v-1.44h1.81v-2.57l1.68-.54v3.11h2.65v1.44h-2.65v5.92c0,.7.12,1.21.36,1.51.24.3.64.45,1.19.45.42,0,.79-.12,1.1-.35v1.44Zm9.4-.38c-.81.49-1.77.73-2.87.73-1.5,0-2.71-.49-3.63-1.46-.92-.98-1.38-2.24-1.38-3.8,0-1.73.5-3.12,1.49-4.17.99-1.05,2.32-1.58,3.97-1.58.92,0,1.74.17,2.44.51v1.72c-.78-.55-1.62-.82-2.5-.82-1.07,0-1.96.39-2.65,1.16-.68.77-1.03,1.78-1.03,3.03s.32,2.2.96,2.92c.65.71,1.52,1.07,2.61,1.07.92,0,1.78-.3,2.59-.91v1.6Zm11.26.48h-1.68v-6.06c0-2.19-.81-3.29-2.44-3.29-.82,0-1.51.32-2.07.95-.56.63-.84,1.44-.84,2.43v5.95h-1.68v-15.56h1.68v6.8h.04c.81-1.33,1.96-1.99,3.45-1.99,2.37,0,3.55,1.43,3.55,4.28v6.48Zm11.61-4.84h-7.42c.03,1.17.34,2.07.94,2.71.6.64,1.43.95,2.48.95,1.18,0,2.27-.39,3.26-1.17v1.58c-.92.67-2.15,1.01-3.66,1.01s-2.65-.48-3.5-1.43c-.85-.96-1.27-2.3-1.27-4.03,0-1.64.46-2.97,1.39-3.99.93-1.03,2.08-1.55,3.46-1.55s2.44.44,3.19,1.33c.75.89,1.13,2.12,1.13,3.71v.88Zm-1.72-1.43c0-.97-.24-1.73-.71-2.27-.46-.54-1.1-.81-1.92-.81s-1.47.28-2.02.85c-.55.57-.9,1.31-1.03,2.23h5.68Zm12.98,6.26h-1.68v-6c0-2.23-.81-3.35-2.44-3.35-.84,0-1.54.32-2.09.95-.55.63-.82,1.43-.82,2.39v6h-1.68v-10.51h1.68v1.75h.04c.79-1.33,1.94-1.99,3.45-1.99,1.15,0,2.03.37,2.64,1.12.61.74.91,1.81.91,3.21v6.43Z" />
				<path d="m375.72,242.94h-7.64v-14.72h1.72v13.16h5.91v1.56Zm2.89-13.18c-.3,0-.56-.1-.77-.31-.21-.21-.32-.47-.32-.78s.11-.57.32-.78c.21-.21.47-.32.77-.32s.57.11.78.32c.22.21.33.47.33.78s-.11.56-.33.77c-.21.21-.47.32-.78.32Zm.82,13.18h-1.68v-10.51h1.68v10.51Zm11.66-10.51l-4.19,10.51h-1.65l-3.98-10.51h1.85l2.67,7.64c.2.56.32,1.05.37,1.47h.04c.07-.53.18-1,.33-1.43l2.79-7.68h1.78Zm2.66-2.67c-.3,0-.56-.1-.77-.31-.21-.21-.32-.47-.32-.78s.11-.57.32-.78c.21-.21.47-.32.77-.32s.57.11.78.32c.22.21.33.47.33.78s-.11.56-.33.77c-.21.21-.47.32-.78.32Zm.82,13.18h-1.68v-10.51h1.68v10.51Zm12.12,0h-1.68v-6c0-2.23-.81-3.35-2.44-3.35-.84,0-1.54.32-2.09.95-.55.63-.82,1.43-.82,2.39v6h-1.68v-10.51h1.68v1.75h.04c.79-1.33,1.94-1.99,3.45-1.99,1.15,0,2.03.37,2.64,1.12.61.74.91,1.81.91,3.21v6.43Zm12.14-.84c0,3.86-1.85,5.79-5.54,5.79-1.3,0-2.44-.25-3.41-.74v-1.68c1.18.66,2.31.99,3.39.99,2.59,0,3.88-1.38,3.88-4.13v-1.15h-.04c-.8,1.34-2.01,2.01-3.61,2.01-1.31,0-2.36-.47-3.16-1.4-.79-.94-1.19-2.19-1.19-3.77,0-1.79.43-3.21,1.28-4.26.86-1.05,2.04-1.58,3.53-1.58s2.47.57,3.15,1.7h.04v-1.46h1.68v9.67Zm-1.68-3.91v-1.55c0-.83-.28-1.55-.85-2.15-.56-.6-1.26-.89-2.1-.89-1.04,0-1.85.38-2.44,1.14-.59.75-.88,1.81-.88,3.17,0,1.17.28,2.11.84,2.81.57.7,1.32,1.05,2.25,1.05s1.71-.34,2.3-1.01c.6-.67.89-1.53.89-2.58Z" />
				<polygon points="428.88 228.22 421.81 245.38 420.24 245.38 427.29 228.22 428.88 228.22" />
				<path d="m430.59,242.94v-14.72h4.07c5.19,0,7.78,2.39,7.78,7.18,0,2.27-.72,4.1-2.17,5.48-1.44,1.38-3.36,2.06-5.78,2.06h-3.9Zm1.72-13.16v11.6h2.2c1.93,0,3.43-.52,4.51-1.55,1.07-1.03,1.61-2.5,1.61-4.39,0-3.77-2.01-5.66-6.02-5.66h-2.3Zm13.58-.02c-.3,0-.56-.1-.77-.31-.21-.21-.32-.47-.32-.78s.11-.57.32-.78c.21-.21.47-.32.77-.32s.57.11.78.32c.22.21.33.47.33.78s-.11.56-.33.77c-.21.21-.47.32-.78.32Zm.82,13.18h-1.68v-10.51h1.68v10.51Zm12.07,0h-1.68v-6c0-2.23-.81-3.35-2.44-3.35-.84,0-1.54.32-2.09.95-.55.63-.82,1.43-.82,2.39v6h-1.68v-10.51h1.68v1.75h.04c.79-1.33,1.94-1.99,3.45-1.99,1.15,0,2.03.37,2.64,1.12.61.74.91,1.81.91,3.21v6.43Zm3.97-13.18c-.3,0-.56-.1-.77-.31-.21-.21-.32-.47-.32-.78s.11-.57.32-.78c.21-.21.47-.32.77-.32s.57.11.78.32c.22.21.33.47.33.78s-.11.56-.33.77c-.21.21-.47.32-.78.32Zm.82,13.18h-1.68v-10.51h1.68v10.51Zm12.07,0h-1.68v-6c0-2.23-.81-3.35-2.44-3.35-.84,0-1.54.32-2.09.95-.55.63-.82,1.43-.82,2.39v6h-1.68v-10.51h1.68v1.75h.04c.79-1.33,1.94-1.99,3.45-1.99,1.15,0,2.03.37,2.64,1.12.61.74.91,1.81.91,3.21v6.43Zm12.08-.84c0,3.86-1.85,5.79-5.54,5.79-1.3,0-2.44-.25-3.41-.74v-1.68c1.18.66,2.31.99,3.39.99,2.59,0,3.88-1.38,3.88-4.13v-1.15h-.04c-.8,1.34-2.01,2.01-3.61,2.01-1.31,0-2.36-.47-3.16-1.4-.79-.94-1.19-2.19-1.19-3.77,0-1.79.43-3.21,1.28-4.26.86-1.05,2.04-1.58,3.53-1.58s2.47.57,3.15,1.7h.04v-1.46h1.68v9.67Zm-1.68-3.91v-1.55c0-.83-.28-1.55-.85-2.15-.56-.6-1.26-.89-2.1-.89-1.04,0-1.85.38-2.44,1.14-.59.75-.88,1.81-.88,3.17,0,1.17.28,2.11.84,2.81.57.7,1.32,1.05,2.25,1.05s1.71-.34,2.3-1.01c.6-.67.89-1.53.89-2.58Z" />
				<path d="m507.85,242.94h-2.05l-2.46-4.13c-.23-.38-.44-.71-.66-.98-.21-.27-.43-.5-.66-.67-.22-.17-.46-.29-.72-.37-.25-.08-.54-.12-.86-.12h-1.42v6.26h-1.72v-14.72h4.39c.64,0,1.24.08,1.78.25.55.16,1.02.4,1.42.73.4.33.72.74.94,1.23.23.49.34,1.06.34,1.71,0,.51-.08.99-.24,1.42-.15.42-.37.8-.66,1.14-.28.34-.62.62-1.03.86-.4.23-.85.41-1.34.54v.04c.25.11.46.24.64.38.18.14.36.3.52.49.16.19.33.41.48.66.16.24.35.52.54.84l2.76,4.42Zm-8.83-13.16v5.34h2.34c.43,0,.83-.07,1.19-.2.37-.13.69-.31.95-.55.27-.25.48-.54.63-.89.15-.36.23-.75.23-1.19,0-.79-.26-1.4-.77-1.84-.51-.44-1.24-.67-2.21-.67h-2.36Zm14.95,13.41c-1.55,0-2.8-.49-3.73-1.47-.92-.99-1.39-2.29-1.39-3.91,0-1.77.48-3.14,1.45-4.14.96-.99,2.27-1.49,3.91-1.49s2.79.48,3.66,1.45c.88.96,1.32,2.3,1.32,4.01s-.48,3.02-1.43,4.03c-.94,1.01-2.21,1.51-3.81,1.51Zm.12-9.59c-1.08,0-1.94.37-2.57,1.11-.63.73-.94,1.75-.94,3.04s.32,2.23.95,2.95c.64.72,1.49,1.08,2.56,1.08s1.92-.35,2.5-1.06c.59-.7.88-1.71.88-3.01s-.29-2.33-.88-3.04c-.58-.71-1.42-1.07-2.5-1.07Zm12.13,9.59c-1.55,0-2.8-.49-3.73-1.47-.92-.99-1.39-2.29-1.39-3.91,0-1.77.48-3.14,1.45-4.14.96-.99,2.27-1.49,3.91-1.49s2.79.48,3.66,1.45c.88.96,1.32,2.3,1.32,4.01s-.48,3.02-1.43,4.03c-.94,1.01-2.21,1.51-3.81,1.51Zm.12-9.59c-1.08,0-1.94.37-2.57,1.11-.63.73-.94,1.75-.94,3.04s.32,2.23.95,2.95c.64.72,1.49,1.08,2.56,1.08s1.92-.35,2.5-1.06c.59-.7.88-1.71.88-3.01s-.29-2.33-.88-3.04c-.58-.71-1.42-1.07-2.5-1.07Zm22.66,9.34h-1.68v-6.04c0-1.16-.18-2.01-.54-2.53-.36-.52-.96-.78-1.81-.78-.72,0-1.33.33-1.84.99-.5.66-.75,1.44-.75,2.36v6h-1.68v-6.24c0-2.07-.8-3.1-2.39-3.1-.74,0-1.35.31-1.83.93-.48.62-.72,1.42-.72,2.41v6h-1.68v-10.51h1.68v1.66h.04c.75-1.27,1.83-1.91,3.26-1.91.72,0,1.34.2,1.88.61.53.4.9.92,1.1,1.57.78-1.45,1.94-2.18,3.49-2.18,2.31,0,3.47,1.43,3.47,4.28v6.48Z" />
				<path d="m421.62,264.76h-1.22v-9.25c-.09.09-.23.2-.42.33-.18.12-.38.24-.61.36-.22.12-.46.23-.72.34-.25.1-.49.19-.73.25v-1.24c.27-.07.55-.17.85-.3.3-.13.6-.27.89-.43.29-.16.57-.32.83-.49.26-.17.48-.34.67-.51h.46v10.95Zm9.2-10.71v7.07h1.37v1.12h-1.37v2.52h-1.21v-2.52h-5.03v-1.06c.47-.53.94-1.09,1.42-1.69.48-.6.93-1.21,1.37-1.83.44-.62.84-1.23,1.21-1.84.37-.62.69-1.21.94-1.77h1.31Zm-4.86,7.07h3.65v-5.24c-.37.65-.73,1.23-1.06,1.75-.33.51-.65.98-.96,1.4-.3.42-.58.8-.86,1.13-.27.34-.53.66-.78.96Z" />
				<rect x="433.95" y="254.05" width="1.08" height="3.34" />
				<path d="m441.96,256.86c0-.33-.05-.61-.16-.86-.1-.24-.24-.45-.42-.6-.17-.16-.38-.29-.62-.37-.24-.08-.5-.12-.78-.12-.24,0-.47.03-.7.1-.23.06-.45.15-.67.27-.21.11-.42.25-.63.41-.2.16-.39.34-.56.53v-1.31c.34-.33.73-.59,1.15-.76.43-.18.95-.27,1.56-.27.44,0,.84.06,1.22.19.37.12.7.31.97.55.27.24.49.55.64.9.16.36.24.77.24,1.23,0,.42-.05.81-.15,1.15-.09.34-.24.67-.44.97-.19.3-.44.59-.74.87-.3.28-.65.56-1.05.85-.5.36-.92.66-1.25.92-.32.25-.58.49-.78.72-.19.22-.32.44-.4.66-.07.22-.11.47-.11.76h5.33v1.1h-6.61v-.53c0-.46.05-.86.15-1.21.1-.35.26-.68.49-.99.23-.31.53-.63.9-.94.37-.31.83-.67,1.37-1.06.39-.28.71-.55.97-.8.26-.25.48-.51.63-.76s.27-.51.34-.77c.07-.26.1-.54.1-.84Z" />
				<path d="m446.75,254.05v3.34h-1.08v-3.34h1.08Zm2.48,0v3.34h-1.08v-3.34h1.08Z" />
				<path d="m461.47,257.11l-2.57,3.87,2.52,3.78h-1.43l-1.5-2.48c-.09-.15-.21-.35-.34-.58h-.03s-.14.24-.35.58l-1.53,2.48h-1.41l2.61-3.75-2.49-3.9h1.43l1.48,2.61c.11.19.22.39.32.6h.03l1.91-3.21h1.35Z" />
				<path d="m471.26,264.76h-1.22v-9.25c-.09.09-.23.2-.42.33-.18.12-.38.24-.61.36-.22.12-.46.23-.72.34-.25.1-.49.19-.73.25v-1.24c.27-.07.55-.17.85-.3.3-.13.6-.27.89-.43.29-.16.57-.32.83-.49.26-.17.48-.34.67-.51h.46v10.95Zm9.2-10.71v7.07h1.37v1.12h-1.37v2.52h-1.21v-2.52h-5.03v-1.06c.47-.53.94-1.09,1.42-1.69.48-.6.93-1.21,1.37-1.83.44-.62.84-1.23,1.21-1.84.37-.62.69-1.21.94-1.77h1.31Zm-4.86,7.07h3.65v-5.24c-.37.65-.73,1.23-1.06,1.75-.33.51-.65.98-.96,1.4-.3.42-.58.8-.86,1.13-.27.34-.53.66-.78.96Z" />
				<rect x="483.58" y="254.05" width="1.08" height="3.34" />
				<path d="m486.5,261.77c0-.28.04-.57.13-.85.09-.29.22-.56.38-.81.17-.25.38-.48.62-.68.25-.2.53-.37.84-.49-.46-.26-.83-.59-1.1-.99-.27-.41-.41-.86-.41-1.35,0-.39.07-.76.22-1.09.15-.33.37-.62.63-.87.27-.24.59-.43.96-.57.37-.14.77-.21,1.19-.21s.83.07,1.2.21.69.33.96.57c.27.24.48.53.63.87.15.33.22.69.22,1.08,0,.49-.14.94-.41,1.35-.27.4-.64.73-1.09.99.31.12.58.28.83.49.24.2.45.43.61.68.17.25.3.52.39.81.09.28.13.57.13.85,0,.47-.08.9-.25,1.28-.17.39-.41.72-.72,1-.3.27-.67.49-1.1.64-.42.15-.89.23-1.4.23s-.97-.08-1.4-.23-.79-.37-1.1-.64c-.31-.28-.55-.61-.72-1-.17-.39-.25-.82-.25-1.28Zm1.33-.1c0,.33.05.63.15.9.1.27.25.5.43.69.19.19.42.34.68.44.27.1.56.15.89.15s.6-.05.87-.16c.26-.1.49-.25.68-.44.19-.19.34-.42.45-.69.11-.27.16-.57.16-.9,0-.3-.05-.58-.16-.84-.1-.26-.24-.5-.43-.69-.19-.2-.42-.36-.68-.47-.26-.11-.56-.17-.89-.17-.31,0-.59.05-.86.16-.26.1-.49.25-.68.45-.19.19-.34.42-.45.69-.11.26-.16.55-.16.87Zm.38-4.96c0,.25.04.49.13.71.09.21.22.4.38.57.16.16.35.29.57.38.21.09.44.13.69.13s.47-.05.69-.14c.22-.09.41-.22.57-.38.16-.16.29-.35.38-.57.09-.22.14-.45.14-.7s-.05-.5-.14-.72c-.09-.22-.21-.41-.37-.57-.16-.16-.35-.28-.57-.37-.21-.09-.45-.14-.69-.14-.26,0-.51.05-.72.14-.21.09-.4.22-.56.39-.15.16-.27.35-.36.57-.08.22-.13.45-.13.7Z" />
				<path d="m496.39,254.05v3.34h-1.08v-3.34h1.08Zm2.48,0v3.34h-1.08v-3.34h1.08Z" />
				<path d="m484.36,907.36l-2.42,8.57h-1.18l-1.76-6.26c-.08-.27-.12-.56-.14-.87h-.02c-.02.29-.08.58-.16.86l-1.77,6.27h-1.16l-2.51-8.57h1.11l1.82,6.57c.08.27.12.56.14.86h.03c.02-.21.08-.5.19-.86l1.89-6.57h.96l1.82,6.62c.06.23.11.49.14.8h.02c.02-.21.07-.48.16-.82l1.75-6.6h1.09Z" />
				<polygon points="489.36 907.36 485.25 917.35 484.33 917.35 488.43 907.36 489.36 907.36" />
				<path d="m490.36,915.93v-8.57h2.37c3.02,0,4.53,1.39,4.53,4.18,0,1.32-.42,2.39-1.26,3.19-.84.8-1.96,1.2-3.36,1.2h-2.27Zm1-7.66v6.75h1.28c1.12,0,2-.3,2.62-.9.63-.6.94-1.45.94-2.56,0-2.19-1.17-3.29-3.5-3.29h-1.34Z" />
			</g>
			<g id="text">
				<path d="m673.02,647.56v-9.41h3.24c.73,0,1.29.05,1.68.13.54.12,1,.35,1.38.67.5.42.87.96,1.11,1.61.25.65.37,1.4.37,2.23,0,.71-.08,1.35-.25,1.9-.17.55-.38,1.01-.64,1.37-.26.36-.55.64-.86.85-.31.21-.68.36-1.12.47-.44.11-.94.16-1.51.16h-3.4Zm1.25-1.11h2.01c.62,0,1.11-.06,1.46-.17.36-.12.64-.28.85-.49.3-.3.52-.69.69-1.19.17-.5.25-1.11.25-1.82,0-.98-.16-1.74-.49-2.27-.32-.53-.71-.89-1.17-1.07-.33-.13-.87-.19-1.61-.19h-1.98v7.19Zm9.9,1.11l-2.5-9.41h1.28l1.43,6.17c.15.65.29,1.29.4,1.93.24-1.01.38-1.59.42-1.74l1.79-6.36h1.5l1.35,4.76c.34,1.18.58,2.29.73,3.33.12-.59.28-1.28.47-2.05l1.48-6.05h1.25l-2.58,9.41h-1.2l-1.98-7.17c-.17-.6-.27-.97-.3-1.1-.1.43-.19.8-.28,1.1l-2,7.17h-1.27Z" />
				<path d="m674.31,851.61h-1.32l-1.59-2.66c-.15-.25-.29-.46-.42-.63-.14-.18-.28-.32-.42-.43-.14-.11-.3-.19-.46-.24-.16-.05-.35-.08-.56-.08h-.91v4.03h-1.11v-9.48h2.83c.41,0,.8.05,1.14.16.35.1.66.26.91.47.26.21.46.48.61.79.15.31.22.68.22,1.1,0,.33-.05.63-.15.91-.1.27-.24.52-.42.73-.18.22-.4.4-.66.56-.26.15-.54.27-.87.35v.03c.16.07.3.15.41.24.12.09.23.19.34.32.11.12.21.26.31.42.11.15.22.33.35.54l1.78,2.85Zm-5.69-8.48v3.44h1.51c.28,0,.53-.04.77-.13.24-.08.44-.2.61-.36.17-.16.31-.35.4-.58.1-.23.15-.48.15-.77,0-.51-.17-.9-.5-1.18-.33-.29-.8-.43-1.42-.43h-1.52Zm12.16,5.36h-4.78c.02.75.22,1.34.61,1.75.39.41.92.61,1.6.61.76,0,1.46-.25,2.1-.75v1.02c-.6.43-1.38.65-2.36.65s-1.71-.31-2.25-.92c-.55-.62-.82-1.48-.82-2.6,0-1.05.3-1.91.89-2.57.6-.67,1.34-1,2.23-1s1.57.29,2.06.86c.48.57.73,1.37.73,2.39v.57Zm-1.11-.92c0-.63-.16-1.11-.46-1.46-.3-.35-.71-.52-1.24-.52s-.95.18-1.3.55-.58.84-.66,1.43h3.66Zm5.97-5.04c-.21-.12-.45-.18-.72-.18-.76,0-1.14.48-1.14,1.43v1.04h1.59v.93h-1.59v5.84h-1.08v-5.84h-1.16v-.93h1.16v-1.1c0-.71.2-1.27.61-1.68.41-.41.92-.62,1.53-.62.33,0,.59.04.79.12v.98Z" />
				<path d="m686.8,851.75c-.2,0-.38-.07-.52-.22-.14-.15-.21-.32-.21-.52s.07-.38.21-.52c.15-.15.32-.22.52-.22s.38.07.53.22c.15.15.22.32.22.52s-.07.38-.22.52c-.15.15-.32.22-.53.22Z" />
				<path d="m376.7,852.27v-14.72h4.19c1.27,0,2.28.31,3.03.93.75.62,1.12,1.43,1.12,2.43,0,.83-.23,1.56-.68,2.18-.45.62-1.07,1.05-1.87,1.31v.04c.99.12,1.79.49,2.38,1.13.6.63.89,1.45.89,2.46,0,1.26-.45,2.28-1.36,3.06-.9.78-2.04,1.17-3.42,1.17h-4.29Zm1.72-13.16v4.75h1.77c.94,0,1.69-.23,2.23-.68.54-.46.81-1.1.81-1.93,0-1.43-.94-2.15-2.82-2.15h-1.98Zm0,6.3v5.3h2.34c1.01,0,1.8-.24,2.35-.72.56-.48.84-1.14.84-1.97,0-1.74-1.18-2.61-3.55-2.61h-1.98Zm17.62,6.86h-1.68v-1.64h-.04c-.73,1.26-1.81,1.89-3.23,1.89-1.05,0-1.87-.28-2.46-.83-.59-.55-.88-1.29-.88-2.21,0-1.96,1.16-3.11,3.47-3.43l3.15-.44c0-1.79-.72-2.68-2.17-2.68-1.27,0-2.41.43-3.43,1.29v-1.72c1.03-.66,2.22-.99,3.57-.99,2.47,0,3.71,1.31,3.71,3.92v6.84Zm-1.68-5.32l-2.54.35c-.78.11-1.37.3-1.77.59-.4.27-.6.76-.6,1.47,0,.51.18.93.54,1.26.37.32.86.48,1.47.48.83,0,1.52-.29,2.06-.87.55-.59.82-1.33.82-2.23v-1.05Zm9.73,5.21c-.4.22-.92.33-1.57.33-1.84,0-2.76-1.03-2.76-3.08v-6.22h-1.81v-1.44h1.81v-2.57l1.68-.54v3.11h2.65v1.44h-2.65v5.92c0,.7.12,1.21.36,1.51.24.3.64.45,1.19.45.42,0,.79-.12,1.1-.35v1.44Zm10.97.1h-1.68v-6.06c0-2.19-.81-3.29-2.44-3.29-.82,0-1.51.32-2.07.95-.56.63-.84,1.44-.84,2.43v5.95h-1.68v-15.56h1.68v6.8h.04c.81-1.33,1.96-1.99,3.45-1.99,2.37,0,3.55,1.43,3.55,4.28v6.48Z" />
				<path d="m567.35,813h-7.8v-14.72h7.47v1.56h-5.75v4.9h5.32v1.55h-5.32v5.15h6.08v1.56Zm11.35,0h-1.68v-6c0-2.23-.81-3.35-2.44-3.35-.84,0-1.54.32-2.09.95-.55.63-.82,1.43-.82,2.39v6h-1.68v-10.51h1.68v1.75h.04c.79-1.33,1.94-1.99,3.45-1.99,1.15,0,2.03.37,2.64,1.12.61.74.91,1.81.91,3.21v6.43Zm8.06-.1c-.4.22-.92.33-1.57.33-1.84,0-2.76-1.03-2.76-3.08v-6.22h-1.81v-1.44h1.81v-2.57l1.68-.54v3.11h2.65v1.44h-2.65v5.92c0,.7.12,1.21.36,1.51.24.3.64.45,1.19.45.42,0,.79-.12,1.1-.35v1.44Zm7.75-8.71c-.29-.23-.72-.34-1.27-.34-.72,0-1.32.34-1.81,1.02-.48.68-.72,1.6-.72,2.77v5.36h-1.68v-10.51h1.68v2.17h.04c.24-.74.61-1.31,1.1-1.72.49-.42,1.04-.63,1.65-.63.44,0,.77.05,1.01.14v1.75Zm10.22-1.7l-4.84,12.2c-.86,2.18-2.07,3.26-3.63,3.26-.44,0-.8-.04-1.1-.13v-1.51c.36.12.69.18,1,.18.85,0,1.49-.51,1.91-1.52l.84-1.99-4.11-10.49h1.87l2.84,8.09c.03.1.11.37.22.8h.06c.03-.16.1-.42.21-.78l2.99-8.11h1.75Z" />
				<path d="m375.72,611.51v-14.72h4.19c1.27,0,2.28.31,3.03.93.75.62,1.12,1.43,1.12,2.43,0,.83-.23,1.56-.68,2.18-.45.62-1.07,1.05-1.87,1.31v.04c.99.12,1.79.49,2.38,1.13.6.63.89,1.45.89,2.46,0,1.26-.45,2.28-1.36,3.06-.9.78-2.04,1.17-3.42,1.17h-4.29Zm1.72-13.16v4.75h1.77c.94,0,1.69-.23,2.23-.68.54-.46.81-1.1.81-1.93,0-1.43-.94-2.15-2.82-2.15h-1.98Zm0,6.3v5.3h2.34c1.01,0,1.8-.24,2.35-.72.56-.48.84-1.14.84-1.97,0-1.74-1.18-2.61-3.55-2.61h-1.98Zm18.53,2.02h-7.42c.03,1.17.34,2.07.94,2.71.6.64,1.43.95,2.48.95,1.18,0,2.27-.39,3.26-1.17v1.58c-.92.67-2.15,1.01-3.66,1.01s-2.65-.48-3.5-1.43c-.85-.96-1.27-2.3-1.27-4.03,0-1.64.46-2.97,1.39-3.99.93-1.03,2.08-1.55,3.46-1.55s2.44.44,3.19,1.33c.75.89,1.13,2.12,1.13,3.71v.88Zm-1.72-1.43c0-.97-.24-1.73-.71-2.27-.46-.54-1.1-.81-1.92-.81s-1.47.28-2.02.85c-.55.57-.9,1.31-1.03,2.23h5.68Zm13.22,6.26h-1.68v-1.79h-.04c-.78,1.36-1.98,2.03-3.61,2.03-1.32,0-2.38-.47-3.17-1.41-.79-.94-1.18-2.23-1.18-3.85,0-1.74.44-3.13,1.31-4.18s2.04-1.57,3.5-1.57,2.49.57,3.15,1.7h.04v-6.51h1.68v15.56Zm-1.68-4.75v-1.55c0-.85-.28-1.57-.84-2.16-.56-.59-1.27-.88-2.14-.88-1.03,0-1.83.38-2.42,1.13-.59.75-.88,1.79-.88,3.12,0,1.21.28,2.17.84,2.87.57.7,1.33,1.05,2.28,1.05s1.7-.34,2.28-1.02c.59-.68.88-1.53.88-2.57Zm10.56-4.05c-.29-.23-.72-.34-1.27-.34-.72,0-1.32.34-1.81,1.02-.48.68-.72,1.6-.72,2.77v5.36h-1.68v-10.51h1.68v2.17h.04c.24-.74.61-1.31,1.1-1.72.49-.42,1.04-.63,1.65-.63.44,0,.77.05,1.01.14v1.75Zm6.21,9.05c-1.55,0-2.8-.49-3.73-1.47-.92-.99-1.39-2.29-1.39-3.91,0-1.77.48-3.14,1.45-4.14.96-.99,2.27-1.49,3.91-1.49s2.79.48,3.66,1.45c.88.96,1.32,2.3,1.32,4.01s-.48,3.02-1.43,4.03c-.94,1.01-2.21,1.51-3.81,1.51Zm.12-9.59c-1.08,0-1.94.37-2.57,1.11-.63.73-.94,1.75-.94,3.04s.32,2.23.95,2.95c.64.72,1.49,1.08,2.56,1.08s1.92-.35,2.5-1.06c.59-.7.88-1.71.88-3.01s-.29-2.33-.88-3.04c-.58-.71-1.42-1.07-2.5-1.07Zm12.18,9.59c-1.55,0-2.8-.49-3.73-1.47-.92-.99-1.39-2.29-1.39-3.91,0-1.77.48-3.14,1.45-4.14.97-.99,2.27-1.49,3.91-1.49s2.79.48,3.66,1.45c.88.96,1.32,2.3,1.32,4.01s-.48,3.02-1.43,4.03c-.94,1.01-2.21,1.51-3.81,1.51Zm.12-9.59c-1.08,0-1.94.37-2.57,1.11-.63.73-.94,1.75-.94,3.04s.32,2.23.95,2.95c.64.72,1.49,1.08,2.56,1.08s1.92-.35,2.5-1.06c.59-.7.88-1.71.88-3.01s-.29-2.33-.88-3.04c-.58-.71-1.42-1.07-2.5-1.07h0Zm22.71,9.34h-1.68v-6.04c0-1.16-.18-2.01-.54-2.53-.36-.52-.96-.78-1.81-.78-.72,0-1.33.33-1.84.99-.5.66-.75,1.44-.75,2.36v6h-1.68v-6.24c0-2.07-.8-3.1-2.39-3.1-.74,0-1.35.31-1.83.93-.48.62-.72,1.42-.72,2.41v6h-1.68v-10.51h1.68v1.66h.04c.75-1.27,1.83-1.91,3.26-1.91.72,0,1.34.2,1.88.61.53.4.9.92,1.1,1.57.78-1.45,1.94-2.18,3.49-2.18,2.31,0,3.47,1.43,3.47,4.28v6.48Z" />
				<path d="m379.92,633.33h-1.22v-9.25c-.09.09-.23.2-.42.33-.18.12-.38.24-.61.36-.22.12-.46.23-.72.34-.25.1-.49.19-.73.25v-1.24c.27-.07.55-.17.85-.3.3-.13.6-.27.89-.43.29-.16.57-.32.83-.49.26-.17.48-.34.67-.51h.46v10.95Zm10.47-5.4c0,.9-.08,1.69-.25,2.38-.16.69-.39,1.28-.7,1.75-.3.47-.68.83-1.13,1.08-.44.24-.95.37-1.52.37-.54,0-1.02-.12-1.44-.35-.42-.24-.77-.58-1.06-1.04-.29-.45-.51-1.01-.66-1.66-.15-.66-.22-1.42-.22-2.27,0-.94.08-1.76.23-2.48.16-.72.39-1.32.69-1.8.3-.49.68-.85,1.13-1.1.45-.25.97-.37,1.55-.37,2.24,0,3.37,1.83,3.37,5.49Zm-1.25.12c0-3.05-.72-4.57-2.17-4.57-1.53,0-2.29,1.55-2.29,4.65,0,2.89.75,4.34,2.25,4.34s2.22-1.47,2.22-4.42Z" />
				<rect x="392.25" y="622.62" width="1.08" height="3.34" />
				<path d="m401.99,627.33c0,.98-.1,1.85-.29,2.62-.19.76-.48,1.41-.85,1.94-.37.53-.83.93-1.37,1.21-.54.27-1.15.41-1.84.41s-1.33-.12-1.87-.37v-1.17c.59.33,1.22.5,1.9.5.48,0,.91-.1,1.29-.3.38-.2.71-.49.97-.87.26-.38.47-.85.6-1.41.14-.56.21-1.2.21-1.92h-.03c-.46.92-1.25,1.38-2.39,1.38-.46,0-.88-.08-1.26-.24-.38-.16-.71-.39-.99-.69-.28-.3-.5-.65-.65-1.06-.15-.41-.23-.86-.23-1.35,0-.53.08-1.01.25-1.45.17-.44.41-.81.72-1.13.31-.32.67-.56,1.09-.74.42-.17.88-.26,1.38-.26.54,0,1.01.11,1.43.33.42.21.77.53,1.05.95.28.41.5.92.65,1.53.15.61.22,1.3.22,2.08Zm-1.32-1.1c0-.41-.05-.79-.16-1.13-.1-.34-.25-.63-.44-.87-.19-.24-.42-.43-.68-.56-.26-.13-.54-.2-.85-.2s-.57.06-.82.18c-.25.11-.48.28-.66.49-.18.21-.33.46-.44.75-.1.29-.16.6-.16.95,0,.38.05.72.15,1.02.1.3.25.55.44.76.19.2.42.36.68.47.27.11.56.16.89.16.28,0,.55-.05.8-.16.25-.11.47-.25.66-.43.19-.18.34-.4.44-.64.11-.25.16-.52.16-.8Z" />
				<path d="m405.05,622.62v3.34h-1.08v-3.34h1.08Zm2.48,0v3.34h-1.08v-3.34h1.08Z" />
				<path d="m419.77,625.68l-2.57,3.87,2.52,3.78h-1.43l-1.5-2.48c-.09-.15-.21-.35-.34-.58h-.03s-.14.24-.35.58l-1.53,2.48h-1.41l2.61-3.75-2.49-3.9h1.43l1.48,2.61c.11.19.22.39.32.6h.03l1.91-3.21h1.35Z" />
				<path d="m429.56,633.33h-1.22v-9.25c-.09.09-.23.2-.42.33-.18.12-.38.24-.61.36-.22.12-.46.23-.72.34-.25.1-.49.19-.73.25v-1.24c.27-.07.55-.17.85-.3.3-.13.6-.27.89-.43.29-.16.57-.32.83-.49.26-.17.48-.34.67-.51h.46v10.95Zm10.47-5.4c0,.9-.08,1.69-.25,2.38-.16.69-.39,1.28-.7,1.75-.3.47-.68.83-1.13,1.08-.44.24-.95.37-1.52.37-.54,0-1.02-.12-1.44-.35-.42-.24-.77-.58-1.06-1.04s-.51-1.01-.66-1.66c-.15-.66-.22-1.42-.22-2.27,0-.94.08-1.76.23-2.48.16-.72.39-1.32.69-1.8.3-.49.68-.85,1.13-1.1.45-.25.97-.37,1.55-.37,2.24,0,3.37,1.83,3.37,5.49Zm-1.25.12c0-3.05-.72-4.57-2.17-4.57-1.53,0-2.29,1.55-2.29,4.65,0,2.89.75,4.34,2.25,4.34s2.22-1.47,2.22-4.42Z" />
				<rect x="441.88" y="622.62" width="1.08" height="3.34" />
				<path d="m449.54,633.33h-1.22v-9.25c-.09.09-.23.2-.42.33-.18.12-.38.24-.61.36-.22.12-.46.23-.72.34-.25.1-.49.19-.73.25v-1.24c.27-.07.55-.17.85-.3.3-.13.6-.27.89-.43.29-.16.57-.32.83-.49.26-.17.48-.34.67-.51h.46v10.95Z" />
				<path d="m454.69,622.62v3.34h-1.08v-3.34h1.08Zm2.48,0v3.34h-1.08v-3.34h1.08Z" />
				<path d="m576.59,693.13h-2.4l-5.69-6.73c-.21-.25-.34-.42-.39-.51h-.04v7.25h-1.72v-14.72h1.72v6.92h.04c.1-.15.23-.32.39-.5l5.5-6.42h2.15l-6.31,7.06,6.75,7.66Zm2.57-13.18c-.3,0-.56-.1-.77-.31-.21-.21-.32-.47-.32-.78s.11-.57.32-.78c.21-.21.47-.32.77-.32s.57.11.78.32c.22.21.33.47.33.78s-.11.56-.33.77c-.21.21-.47.32-.78.32Zm.82,13.18h-1.68v-10.51h1.68v10.51Zm8.27-.1c-.4.22-.92.33-1.57.33-1.84,0-2.76-1.03-2.76-3.08v-6.22h-1.81v-1.44h1.81v-2.57l1.68-.54v3.11h2.65v1.44h-2.65v5.92c0,.7.12,1.21.36,1.51.24.3.64.45,1.19.45.42,0,.79-.12,1.1-.35v1.44Zm9.4-.38c-.81.49-1.77.73-2.87.73-1.5,0-2.71-.49-3.63-1.46-.92-.98-1.38-2.24-1.38-3.8,0-1.73.5-3.12,1.49-4.17.99-1.05,2.32-1.58,3.97-1.58.92,0,1.74.17,2.44.51v1.72c-.78-.55-1.62-.82-2.5-.82-1.07,0-1.96.39-2.65,1.16-.68.77-1.03,1.78-1.03,3.03s.32,2.2.96,2.92c.65.71,1.52,1.07,2.61,1.07.92,0,1.78-.3,2.59-.91v1.6Zm11.26.48h-1.68v-6.06c0-2.19-.81-3.29-2.44-3.29-.82,0-1.51.32-2.07.95-.56.63-.84,1.44-.84,2.43v5.95h-1.68v-15.56h1.68v6.8h.04c.81-1.33,1.96-1.99,3.45-1.99,2.37,0,3.55,1.43,3.55,4.28v6.48Zm11.61-4.84h-7.42c.03,1.17.34,2.07.94,2.71.6.64,1.43.95,2.48.95,1.18,0,2.27-.39,3.26-1.17v1.58c-.92.67-2.15,1.01-3.66,1.01s-2.65-.48-3.5-1.43c-.85-.96-1.27-2.3-1.27-4.03,0-1.64.46-2.97,1.39-3.99.93-1.03,2.08-1.55,3.46-1.55s2.44.44,3.19,1.33c.75.89,1.13,2.12,1.13,3.71v.88Zm-1.72-1.43c0-.97-.24-1.73-.71-2.27-.46-.54-1.1-.81-1.92-.81s-1.47.28-2.02.85c-.55.57-.9,1.31-1.03,2.23h5.68Zm12.98,6.26h-1.68v-6c0-2.23-.81-3.35-2.44-3.35-.84,0-1.54.32-2.09.95-.55.63-.82,1.43-.82,2.39v6h-1.68v-10.51h1.68v1.75h.04c.79-1.33,1.94-1.99,3.45-1.99,1.15,0,2.03.37,2.64,1.12.61.74.91,1.81.91,3.21v6.43Z" />
				<path d="m375.72,242.94h-7.64v-14.72h1.72v13.16h5.91v1.56Zm2.89-13.18c-.3,0-.56-.1-.77-.31-.21-.21-.32-.47-.32-.78s.11-.57.32-.78c.21-.21.47-.32.77-.32s.57.11.78.32c.22.21.33.47.33.78s-.11.56-.33.77c-.21.21-.47.32-.78.32Zm.82,13.18h-1.68v-10.51h1.68v10.51Zm11.66-10.51l-4.19,10.51h-1.65l-3.98-10.51h1.85l2.67,7.64c.2.56.32,1.05.37,1.47h.04c.07-.53.18-1,.33-1.43l2.79-7.68h1.78Zm2.66-2.67c-.3,0-.56-.1-.77-.31-.21-.21-.32-.47-.32-.78s.11-.57.32-.78c.21-.21.47-.32.77-.32s.57.11.78.32c.22.21.33.47.33.78s-.11.56-.33.77c-.21.21-.47.32-.78.32Zm.82,13.18h-1.68v-10.51h1.68v10.51Zm12.12,0h-1.68v-6c0-2.23-.81-3.35-2.44-3.35-.84,0-1.54.32-2.09.95-.55.63-.82,1.43-.82,2.39v6h-1.68v-10.51h1.68v1.75h.04c.79-1.33,1.94-1.99,3.45-1.99,1.15,0,2.03.37,2.64,1.12.61.74.91,1.81.91,3.21v6.43Zm12.14-.84c0,3.86-1.85,5.79-5.54,5.79-1.3,0-2.44-.25-3.41-.74v-1.68c1.18.66,2.31.99,3.39.99,2.59,0,3.88-1.38,3.88-4.13v-1.15h-.04c-.8,1.34-2.01,2.01-3.61,2.01-1.31,0-2.36-.47-3.16-1.4-.79-.94-1.19-2.19-1.19-3.77,0-1.79.43-3.21,1.28-4.26.86-1.05,2.04-1.58,3.53-1.58s2.47.57,3.15,1.7h.04v-1.46h1.68v9.67Zm-1.68-3.91v-1.55c0-.83-.28-1.55-.85-2.15-.56-.6-1.26-.89-2.1-.89-1.04,0-1.85.38-2.44,1.14-.59.75-.88,1.81-.88,3.17,0,1.17.28,2.11.84,2.81.57.7,1.32,1.05,2.25,1.05s1.71-.34,2.3-1.01c.6-.67.89-1.53.89-2.58Z" />
				<polygon points="428.88 228.22 421.81 245.38 420.24 245.38 427.29 228.22 428.88 228.22" />
				<path d="m430.59,242.94v-14.72h4.07c5.19,0,7.78,2.39,7.78,7.18,0,2.27-.72,4.1-2.17,5.48-1.44,1.38-3.36,2.06-5.78,2.06h-3.9Zm1.72-13.16v11.6h2.2c1.93,0,3.43-.52,4.51-1.55,1.07-1.03,1.61-2.5,1.61-4.39,0-3.77-2.01-5.66-6.02-5.66h-2.3Zm13.58-.02c-.3,0-.56-.1-.77-.31-.21-.21-.32-.47-.32-.78s.11-.57.32-.78c.21-.21.47-.32.77-.32s.57.11.78.32c.22.21.33.47.33.78s-.11.56-.33.77c-.21.21-.47.32-.78.32Zm.82,13.18h-1.68v-10.51h1.68v10.51Zm12.07,0h-1.68v-6c0-2.23-.81-3.35-2.44-3.35-.84,0-1.54.32-2.09.95-.55.63-.82,1.43-.82,2.39v6h-1.68v-10.51h1.68v1.75h.04c.79-1.33,1.94-1.99,3.45-1.99,1.15,0,2.03.37,2.64,1.12.61.74.91,1.81.91,3.21v6.43Zm3.97-13.18c-.3,0-.56-.1-.77-.31-.21-.21-.32-.47-.32-.78s.11-.57.32-.78c.21-.21.47-.32.77-.32s.57.11.78.32c.22.21.33.47.33.78s-.11.56-.33.77c-.21.21-.47.32-.78.32Zm.82,13.18h-1.68v-10.51h1.68v10.51Zm12.07,0h-1.68v-6c0-2.23-.81-3.35-2.44-3.35-.84,0-1.54.32-2.09.95-.55.63-.82,1.43-.82,2.39v6h-1.68v-10.51h1.68v1.75h.04c.79-1.33,1.94-1.99,3.45-1.99,1.15,0,2.03.37,2.64,1.12.61.74.91,1.81.91,3.21v6.43Zm12.08-.84c0,3.86-1.85,5.79-5.54,5.79-1.3,0-2.44-.25-3.41-.74v-1.68c1.18.66,2.31.99,3.39.99,2.59,0,3.88-1.38,3.88-4.13v-1.15h-.04c-.8,1.34-2.01,2.01-3.61,2.01-1.31,0-2.36-.47-3.16-1.4-.79-.94-1.19-2.19-1.19-3.77,0-1.79.43-3.21,1.28-4.26.86-1.05,2.04-1.58,3.53-1.58s2.47.57,3.15,1.7h.04v-1.46h1.68v9.67Zm-1.68-3.91v-1.55c0-.83-.28-1.55-.85-2.15-.56-.6-1.26-.89-2.1-.89-1.04,0-1.85.38-2.44,1.14-.59.75-.88,1.81-.88,3.17,0,1.17.28,2.11.84,2.81.57.7,1.32,1.05,2.25,1.05s1.71-.34,2.3-1.01c.6-.67.89-1.53.89-2.58Z" />
				<path d="m507.85,242.94h-2.05l-2.46-4.13c-.23-.38-.44-.71-.66-.98-.21-.27-.43-.5-.66-.67-.22-.17-.46-.29-.72-.37-.25-.08-.54-.12-.86-.12h-1.42v6.26h-1.72v-14.72h4.39c.64,0,1.24.08,1.78.25.55.16,1.02.4,1.42.73.4.33.72.74.94,1.23.23.49.34,1.06.34,1.71,0,.51-.08.99-.24,1.42-.15.42-.37.8-.66,1.14-.28.34-.62.62-1.03.86-.4.23-.85.41-1.34.54v.04c.25.11.46.24.64.38.18.14.36.3.52.49.16.19.33.41.48.66.16.24.35.52.54.84l2.76,4.42Zm-8.83-13.16v5.34h2.34c.43,0,.83-.07,1.19-.2.37-.13.69-.31.95-.55.27-.25.48-.54.63-.89.15-.36.23-.75.23-1.19,0-.79-.26-1.4-.77-1.84-.51-.44-1.24-.67-2.21-.67h-2.36Zm14.95,13.41c-1.55,0-2.8-.49-3.73-1.47-.92-.99-1.39-2.29-1.39-3.91,0-1.77.48-3.14,1.45-4.14.96-.99,2.27-1.49,3.91-1.49s2.79.48,3.66,1.45c.88.96,1.32,2.3,1.32,4.01s-.48,3.02-1.43,4.03c-.94,1.01-2.21,1.51-3.81,1.51Zm.12-9.59c-1.08,0-1.94.37-2.57,1.11-.63.73-.94,1.75-.94,3.04s.32,2.23.95,2.95c.64.72,1.49,1.08,2.56,1.08s1.92-.35,2.5-1.06c.59-.7.88-1.71.88-3.01s-.29-2.33-.88-3.04c-.58-.71-1.42-1.07-2.5-1.07Zm12.13,9.59c-1.55,0-2.8-.49-3.73-1.47-.92-.99-1.39-2.29-1.39-3.91,0-1.77.48-3.14,1.45-4.14.96-.99,2.27-1.49,3.91-1.49s2.79.48,3.66,1.45c.88.96,1.32,2.3,1.32,4.01s-.48,3.02-1.43,4.03c-.94,1.01-2.21,1.51-3.81,1.51Zm.12-9.59c-1.08,0-1.94.37-2.57,1.11-.63.73-.94,1.75-.94,3.04s.32,2.23.95,2.95c.64.72,1.49,1.08,2.56,1.08s1.92-.35,2.5-1.06c.59-.7.88-1.71.88-3.01s-.29-2.33-.88-3.04c-.58-.71-1.42-1.07-2.5-1.07Zm22.66,9.34h-1.68v-6.04c0-1.16-.18-2.01-.54-2.53-.36-.52-.96-.78-1.81-.78-.72,0-1.33.33-1.84.99-.5.66-.75,1.44-.75,2.36v6h-1.68v-6.24c0-2.07-.8-3.1-2.39-3.1-.74,0-1.35.31-1.83.93-.48.62-.72,1.42-.72,2.41v6h-1.68v-10.51h1.68v1.66h.04c.75-1.27,1.83-1.91,3.26-1.91.72,0,1.34.2,1.88.61.53.4.9.92,1.1,1.57.78-1.45,1.94-2.18,3.49-2.18,2.31,0,3.47,1.43,3.47,4.28v6.48Z" />
				<path d="m421.62,264.76h-1.22v-9.25c-.09.09-.23.2-.42.33-.18.12-.38.24-.61.36-.22.12-.46.23-.72.34-.25.1-.49.19-.73.25v-1.24c.27-.07.55-.17.85-.3.3-.13.6-.27.89-.43.29-.16.57-.32.83-.49.26-.17.48-.34.67-.51h.46v10.95Zm9.2-10.71v7.07h1.37v1.12h-1.37v2.52h-1.21v-2.52h-5.03v-1.06c.47-.53.94-1.09,1.42-1.69.48-.6.93-1.21,1.37-1.83.44-.62.84-1.23,1.21-1.84.37-.62.69-1.21.94-1.77h1.31Zm-4.86,7.07h3.65v-5.24c-.37.65-.73,1.23-1.06,1.75-.33.51-.65.98-.96,1.4-.3.42-.58.8-.86,1.13-.27.34-.53.66-.78.96Z" />
				<rect x="433.95" y="254.05" width="1.08" height="3.34" />
				<path d="m441.96,256.86c0-.33-.05-.61-.16-.86-.1-.24-.24-.45-.42-.6-.17-.16-.38-.29-.62-.37-.24-.08-.5-.12-.78-.12-.24,0-.47.03-.7.1-.23.06-.45.15-.67.27-.21.11-.42.25-.63.41-.2.16-.39.34-.56.53v-1.31c.34-.33.73-.59,1.15-.76.43-.18.95-.27,1.56-.27.44,0,.84.06,1.22.19.37.12.7.31.97.55.27.24.49.55.64.9.16.36.24.77.24,1.23,0,.42-.05.81-.15,1.15-.09.34-.24.67-.44.97-.19.3-.44.59-.74.87-.3.28-.65.56-1.05.85-.5.36-.92.66-1.25.92-.32.25-.58.49-.78.72-.19.22-.32.44-.4.66-.07.22-.11.47-.11.76h5.33v1.1h-6.61v-.53c0-.46.05-.86.15-1.21.1-.35.26-.68.49-.99.23-.31.53-.63.9-.94.37-.31.83-.67,1.37-1.06.39-.28.71-.55.97-.8.26-.25.48-.51.63-.76s.27-.51.34-.77c.07-.26.1-.54.1-.84Z" />
				<path d="m446.75,254.05v3.34h-1.08v-3.34h1.08Zm2.48,0v3.34h-1.08v-3.34h1.08Z" />
				<path d="m461.47,257.11l-2.57,3.87,2.52,3.78h-1.43l-1.5-2.48c-.09-.15-.21-.35-.34-.58h-.03s-.14.24-.35.58l-1.53,2.48h-1.41l2.61-3.75-2.49-3.9h1.43l1.48,2.61c.11.19.22.39.32.6h.03l1.91-3.21h1.35Z" />
				<path d="m471.26,264.76h-1.22v-9.25c-.09.09-.23.2-.42.33-.18.12-.38.24-.61.36-.22.12-.46.23-.72.34-.25.1-.49.19-.73.25v-1.24c.27-.07.55-.17.85-.3.3-.13.6-.27.89-.43.29-.16.57-.32.83-.49.26-.17.48-.34.67-.51h.46v10.95Zm9.2-10.71v7.07h1.37v1.12h-1.37v2.52h-1.21v-2.52h-5.03v-1.06c.47-.53.94-1.09,1.42-1.69.48-.6.93-1.21,1.37-1.83.44-.62.84-1.23,1.21-1.84.37-.62.69-1.21.94-1.77h1.31Zm-4.86,7.07h3.65v-5.24c-.37.65-.73,1.23-1.06,1.75-.33.51-.65.98-.96,1.4-.3.42-.58.8-.86,1.13-.27.34-.53.66-.78.96Z" />
				<rect x="483.58" y="254.05" width="1.08" height="3.34" />
				<path d="m486.5,261.77c0-.28.04-.57.13-.85.09-.29.22-.56.38-.81.17-.25.38-.48.62-.68.25-.2.53-.37.84-.49-.46-.26-.83-.59-1.1-.99-.27-.41-.41-.86-.41-1.35,0-.39.07-.76.22-1.09.15-.33.37-.62.63-.87.27-.24.59-.43.96-.57.37-.14.77-.21,1.19-.21s.83.07,1.2.21.69.33.96.57c.27.24.48.53.63.87.15.33.22.69.22,1.08,0,.49-.14.94-.41,1.35-.27.4-.64.73-1.09.99.31.12.58.28.83.49.24.2.45.43.61.68.17.25.3.52.39.81.09.28.13.57.13.85,0,.47-.08.9-.25,1.28-.17.39-.41.72-.72,1-.3.27-.67.49-1.1.64-.42.15-.89.23-1.4.23s-.97-.08-1.4-.23-.79-.37-1.1-.64c-.31-.28-.55-.61-.72-1-.17-.39-.25-.82-.25-1.28Zm1.33-.1c0,.33.05.63.15.9.1.27.25.5.43.69.19.19.42.34.68.44.27.1.56.15.89.15s.6-.05.87-.16c.26-.1.49-.25.68-.44.19-.19.34-.42.45-.69.11-.27.16-.57.16-.9,0-.3-.05-.58-.16-.84-.1-.26-.24-.5-.43-.69-.19-.2-.42-.36-.68-.47-.26-.11-.56-.17-.89-.17-.31,0-.59.05-.86.16-.26.1-.49.25-.68.45-.19.19-.34.42-.45.69-.11.26-.16.55-.16.87Zm.38-4.96c0,.25.04.49.13.71.09.21.22.4.38.57.16.16.35.29.57.38.21.09.44.13.69.13s.47-.05.69-.14c.22-.09.41-.22.57-.38.16-.16.29-.35.38-.57.09-.22.14-.45.14-.7s-.05-.5-.14-.72c-.09-.22-.21-.41-.37-.57-.16-.16-.35-.28-.57-.37-.21-.09-.45-.14-.69-.14-.26,0-.51.05-.72.14-.21.09-.4.22-.56.39-.15.16-.27.35-.36.57-.08.22-.13.45-.13.7Z" />
				<path d="m496.39,254.05v3.34h-1.08v-3.34h1.08Zm2.48,0v3.34h-1.08v-3.34h1.08Z" />
				<path d="m484.36,907.36l-2.42,8.57h-1.18l-1.76-6.26c-.08-.27-.12-.56-.14-.87h-.02c-.02.29-.08.58-.16.86l-1.77,6.27h-1.16l-2.51-8.57h1.11l1.82,6.57c.08.27.12.56.14.86h.03c.02-.21.08-.5.19-.86l1.89-6.57h.96l1.82,6.62c.06.23.11.49.14.8h.02c.02-.21.07-.48.16-.82l1.75-6.6h1.09Z" />
				<polygon points="489.36 907.36 485.25 917.35 484.33 917.35 488.43 907.36 489.36 907.36" />
				<path d="m490.36,915.93v-8.57h2.37c3.02,0,4.53,1.39,4.53,4.18,0,1.32-.42,2.39-1.26,3.19-.84.8-1.96,1.2-3.36,1.2h-2.27Zm1-7.66v6.75h1.28c1.12,0,2-.3,2.62-.9.63-.6.94-1.45.94-2.56,0-2.19-1.17-3.29-3.5-3.29h-1.34Z" />
			</g>
		</g>
	)
}

export default PlanHH
